export const COLOR_TRANSPARENT = "eon-transparent";
export const COLOR_WHITE = "eon-white";
export const COLOR_SYSTEM_SUCCESS_LIGHT = "eon-system-success-light";
export const COLOR_SYSTEM_SUCCESS = "eon-system-success";
export const COLOR_SYSTEM_SUCCESS_DARK = "eon-system-success-dark";
export const COLOR_SYSTEM_WARNING_LIGHT = "eon-system-warning-light";
export const COLOR_SYSTEM_WARNING = "eon-system-warning";
export const COLOR_SYSTEM_WARNING_DARK = "eon-system-warning-dark";
export const COLOR_SYSTEM_ERROR_LIGHT = "eon-system-error-light";
export const COLOR_SYSTEM_ERROR = "eon-system-error";
export const COLOR_SYSTEM_ERROR_DARK = "eon-system-error-dark";
export const COLOR_SYSTEM_HIGHLIGHT_LIGHT = "eon-system-highlight-light";
export const COLOR_SYSTEM_HIGHLIGHT = "eon-system-highlight";
export const COLOR_SYSTEM_HIGHLIGHT_DARK = "eon-system-highlight-dark";
export const COLOR_GREY100 = "eon-grey100";
export const COLOR_GREY200 = "eon-grey200";
export const COLOR_GREY300 = "eon-grey300";
export const COLOR_GREY400 = "eon-grey400";
export const COLOR_GREY500 = "eon-grey500";
export const COLOR_GREY600 = "eon-grey600";
export const COLOR_GREY700 = "eon-grey700";
export const COLOR_GREY800 = "eon-grey800";
export const COLOR_GREY900 = "eon-grey900";

export const COLOR_BRIGHT = "eon-bright";
export const COLOR_DARK = "eon-dark";
export const COLOR_SCHWARZ = "eon-schwarz";
export const COLOR_ORIENTGELB = "eon-orientgelb";
export const COLOR_FASERGRUEN = "eon-fasergruen";
export const COLOR_ARKTISGRUEN = "eon-arktisgruen";
export const COLOR_KARIBIKBLAU = "eon-karibikblau";
export const COLOR_BISCHOFSROT = "eon-bischofsrot";
export const COLOR_ALTROSA = "eon-altrosa";
export const COLOR_KERZENGELB = "eon-kerzengelb";
export const COLOR_BRILLANTKARMIN = "eon-brillantkarmin";
export const COLOR_ERDBEERROT = "eon-erdbeerrot";
export const COLOR_VERKEHRSORANGE = "eon-verkehrsorange";
export const COLOR_DAHLIENGELB = "eon-dahliengelb";
export const COLOR_LEUCHTENDGRUEN = "eon-leuchtendgruen";
export const COLOR_INDIABLAU = "eon-indiablau";
export const COLOR_ALPENBLAU = "eon-alpenblau";
export const COLOR_QUARTZGRAU10 = "eon-quartzgrau10";
export const COLOR_QUARTZGRAU20 = "eon-quartzgrau20";
export const COLOR_QUARTZGRAU50 = "eon-quartzgrau50";
export const COLOR_QUARTZGRAU75 = "eon-quartzgrau75";
export const COLOR_BRIGHT_FONT = "eon-bright-font";
export const COLOR_DARK_FONT = "eon-dark-font";
export const COLOR_SCHWARZ_FONT = "eon-schwarz-font";
export const COLOR_ORIENTGELB_FONT = "eon-orientgelb-font";
export const COLOR_FASERGRUEN_FONT = "eon-fasergruen-font";
export const COLOR_ARKTISGRUEN_FONT = "eon-arktisgruen-font";
export const COLOR_KARIBIKBLAU_FONT = "eon-karibikblau-font";
export const COLOR_BISCHOFSROT_FONT = "eon-bischofsrot-font";
export const COLOR_ALTROSA_FONT = "eon-altrosa-font";
export const COLOR_KERZENGELB_FONT = "eon-kerzengelb-font";
export const COLOR_BRILLANTKARMIN_FONT = "eon-brillantkarmin-font";
export const COLOR_ERDBEERROT_FONT = "eon-erdbeerrot-font";
export const COLOR_VERKEHRSORANGE_FONT = "eon-verkehrsorange-font";
export const COLOR_DAHLIENGELB_FONT = "eon-dahliengelb-font";
export const COLOR_LEUCHTENDGRUEN_FONT = "eon-leuchtendgruen-font";
export const COLOR_INDIABLAU_FONT = "eon-indiablau-font";
export const COLOR_ALPENBLAU_FONT = "eon-alpenblau-font";
export const COLOR_QUARTZGRAU10_FONT = "eon-quartzgrau10-font";
export const COLOR_QUARTZGRAU20_FONT = "eon-quartzgrau20-font";
export const COLOR_QUARTZGRAU50_FONT = "eon-quartzgrau50-font";
export const COLOR_QUARTZGRAU75_FONT = "eon-quartzgrau75-font";
export const COLOR_RED = "eon-red";
export const COLOR_QUARTZGRAU = "eon-quartzgrau";
export const COLOR_SOMMERGELB = "eon-sommergelb";
export const COLOR_SYSTEM_SUCCESS_LIGHT1 = "eon-system-success-light1";
export const COLOR_SYSTEM_SUCCESS1 = "eon-system-success1";
export const COLOR_SYSTEM_SUCCESS_DARK1 = "eon-system-success-dark1";
export const COLOR_SYSTEM_WARNING_LIGHT1 = "eon-system-warning-light1";
export const COLOR_SYSTEM_WARNING1 = "eon-system-warning1";
export const COLOR_SYSTEM_WARNING_DARK1 = "eon-system-warning-dark1";
export const COLOR_SYSTEM_ERROR_LIGHT1 = "eon-system-error-light1";
export const COLOR_SYSTEM_ERROR1 = "eon-system-error1";
export const COLOR_SYSTEM_ERROR_DARK1 = "eon-system-error-dark1";
export const COLOR_SYSTEM_HIGHLIGHT_LIGHT1 = "eon-system-highlight-light1";
export const COLOR_SYSTEM_HIGHLIGHT1 = "eon-system-highlight1";
export const COLOR_SYSTEM_HIGHLIGHT_DARK1 = "eon-system-highlight-dark1";
export const COLOR_BRIGHT_SHADE_1 = "eon-bright-shade-1";
export const COLOR_BRIGHT_SHADE_2 = "eon-bright-shade-2";
export const COLOR_BRIGHT_TINT_1 = "eon-bright-tint-1";
export const COLOR_BRIGHT_TINT_2 = "eon-bright-tint-2";
export const COLOR_BRIGHT_5 = "eon-bright-5";
export const COLOR_BRIGHT_10 = "eon-bright-10";
export const COLOR_BRIGHT_15 = "eon-bright-15";
export const COLOR_BRIGHT_20 = "eon-bright-20";
export const COLOR_BRIGHT_25 = "eon-bright-25";
export const COLOR_BRIGHT_30 = "eon-bright-30";
export const COLOR_BRIGHT_35 = "eon-bright-35";
export const COLOR_BRIGHT_40 = "eon-bright-40";
export const COLOR_BRIGHT_45 = "eon-bright-45";
export const COLOR_BRIGHT_50 = "eon-bright-50";
export const COLOR_BRIGHT_55 = "eon-bright-55";
export const COLOR_BRIGHT_60 = "eon-bright-60";
export const COLOR_BRIGHT_65 = "eon-bright-65";
export const COLOR_BRIGHT_70 = "eon-bright-70";
export const COLOR_BRIGHT_75 = "eon-bright-75";
export const COLOR_BRIGHT_80 = "eon-bright-80";
export const COLOR_BRIGHT_85 = "eon-bright-85";
export const COLOR_BRIGHT_90 = "eon-bright-90";
export const COLOR_BRIGHT_95 = "eon-bright-95";
export const COLOR_BRIGHT_OPACITY_5 = "eon-bright-opacity-5";
export const COLOR_BRIGHT_OPACITY_10 = "eon-bright-opacity-10";
export const COLOR_BRIGHT_OPACITY_15 = "eon-bright-opacity-15";
export const COLOR_BRIGHT_OPACITY_20 = "eon-bright-opacity-20";
export const COLOR_BRIGHT_OPACITY_25 = "eon-bright-opacity-25";
export const COLOR_BRIGHT_OPACITY_30 = "eon-bright-opacity-30";
export const COLOR_BRIGHT_OPACITY_35 = "eon-bright-opacity-35";
export const COLOR_BRIGHT_OPACITY_40 = "eon-bright-opacity-40";
export const COLOR_BRIGHT_OPACITY_45 = "eon-bright-opacity-45";
export const COLOR_BRIGHT_OPACITY_50 = "eon-bright-opacity-50";
export const COLOR_BRIGHT_OPACITY_55 = "eon-bright-opacity-55";
export const COLOR_BRIGHT_OPACITY_60 = "eon-bright-opacity-60";
export const COLOR_BRIGHT_OPACITY_65 = "eon-bright-opacity-65";
export const COLOR_BRIGHT_OPACITY_70 = "eon-bright-opacity-70";
export const COLOR_BRIGHT_OPACITY_75 = "eon-bright-opacity-75";
export const COLOR_BRIGHT_OPACITY_80 = "eon-bright-opacity-80";
export const COLOR_BRIGHT_OPACITY_85 = "eon-bright-opacity-85";
export const COLOR_BRIGHT_OPACITY_90 = "eon-bright-opacity-90";
export const COLOR_BRIGHT_OPACITY_95 = "eon-bright-opacity-95";
export const COLOR_DARK_SHADE_1 = "eon-dark-shade-1";
export const COLOR_DARK_SHADE_2 = "eon-dark-shade-2";
export const COLOR_DARK_TINT_1 = "eon-dark-tint-1";
export const COLOR_DARK_TINT_2 = "eon-dark-tint-2";
export const COLOR_DARK_5 = "eon-dark-5";
export const COLOR_DARK_10 = "eon-dark-10";
export const COLOR_DARK_15 = "eon-dark-15";
export const COLOR_DARK_20 = "eon-dark-20";
export const COLOR_DARK_25 = "eon-dark-25";
export const COLOR_DARK_30 = "eon-dark-30";
export const COLOR_DARK_35 = "eon-dark-35";
export const COLOR_DARK_40 = "eon-dark-40";
export const COLOR_DARK_45 = "eon-dark-45";
export const COLOR_DARK_50 = "eon-dark-50";
export const COLOR_DARK_55 = "eon-dark-55";
export const COLOR_DARK_60 = "eon-dark-60";
export const COLOR_DARK_65 = "eon-dark-65";
export const COLOR_DARK_70 = "eon-dark-70";
export const COLOR_DARK_75 = "eon-dark-75";
export const COLOR_DARK_80 = "eon-dark-80";
export const COLOR_DARK_85 = "eon-dark-85";
export const COLOR_DARK_90 = "eon-dark-90";
export const COLOR_DARK_95 = "eon-dark-95";
export const COLOR_DARK_OPACITY_5 = "eon-dark-opacity-5";
export const COLOR_DARK_OPACITY_10 = "eon-dark-opacity-10";
export const COLOR_DARK_OPACITY_15 = "eon-dark-opacity-15";
export const COLOR_DARK_OPACITY_20 = "eon-dark-opacity-20";
export const COLOR_DARK_OPACITY_25 = "eon-dark-opacity-25";
export const COLOR_DARK_OPACITY_30 = "eon-dark-opacity-30";
export const COLOR_DARK_OPACITY_35 = "eon-dark-opacity-35";
export const COLOR_DARK_OPACITY_40 = "eon-dark-opacity-40";
export const COLOR_DARK_OPACITY_45 = "eon-dark-opacity-45";
export const COLOR_DARK_OPACITY_50 = "eon-dark-opacity-50";
export const COLOR_DARK_OPACITY_55 = "eon-dark-opacity-55";
export const COLOR_DARK_OPACITY_60 = "eon-dark-opacity-60";
export const COLOR_DARK_OPACITY_65 = "eon-dark-opacity-65";
export const COLOR_DARK_OPACITY_70 = "eon-dark-opacity-70";
export const COLOR_DARK_OPACITY_75 = "eon-dark-opacity-75";
export const COLOR_DARK_OPACITY_80 = "eon-dark-opacity-80";
export const COLOR_DARK_OPACITY_85 = "eon-dark-opacity-85";
export const COLOR_DARK_OPACITY_90 = "eon-dark-opacity-90";
export const COLOR_DARK_OPACITY_95 = "eon-dark-opacity-95";
export const COLOR_SCHWARZ_SHADE_1 = "eon-schwarz-shade-1";
export const COLOR_SCHWARZ_SHADE_2 = "eon-schwarz-shade-2";
export const COLOR_SCHWARZ_TINT_1 = "eon-schwarz-tint-1";
export const COLOR_SCHWARZ_TINT_2 = "eon-schwarz-tint-2";
export const COLOR_SCHWARZ_5 = "eon-schwarz-5";
export const COLOR_SCHWARZ_10 = "eon-schwarz-10";
export const COLOR_SCHWARZ_15 = "eon-schwarz-15";
export const COLOR_SCHWARZ_20 = "eon-schwarz-20";
export const COLOR_SCHWARZ_25 = "eon-schwarz-25";
export const COLOR_SCHWARZ_30 = "eon-schwarz-30";
export const COLOR_SCHWARZ_35 = "eon-schwarz-35";
export const COLOR_SCHWARZ_40 = "eon-schwarz-40";
export const COLOR_SCHWARZ_45 = "eon-schwarz-45";
export const COLOR_SCHWARZ_50 = "eon-schwarz-50";
export const COLOR_SCHWARZ_55 = "eon-schwarz-55";
export const COLOR_SCHWARZ_60 = "eon-schwarz-60";
export const COLOR_SCHWARZ_65 = "eon-schwarz-65";
export const COLOR_SCHWARZ_70 = "eon-schwarz-70";
export const COLOR_SCHWARZ_75 = "eon-schwarz-75";
export const COLOR_SCHWARZ_80 = "eon-schwarz-80";
export const COLOR_SCHWARZ_85 = "eon-schwarz-85";
export const COLOR_SCHWARZ_90 = "eon-schwarz-90";
export const COLOR_SCHWARZ_95 = "eon-schwarz-95";
export const COLOR_SCHWARZ_OPACITY_5 = "eon-schwarz-opacity-5";
export const COLOR_SCHWARZ_OPACITY_10 = "eon-schwarz-opacity-10";
export const COLOR_SCHWARZ_OPACITY_15 = "eon-schwarz-opacity-15";
export const COLOR_SCHWARZ_OPACITY_20 = "eon-schwarz-opacity-20";
export const COLOR_SCHWARZ_OPACITY_25 = "eon-schwarz-opacity-25";
export const COLOR_SCHWARZ_OPACITY_30 = "eon-schwarz-opacity-30";
export const COLOR_SCHWARZ_OPACITY_35 = "eon-schwarz-opacity-35";
export const COLOR_SCHWARZ_OPACITY_40 = "eon-schwarz-opacity-40";
export const COLOR_SCHWARZ_OPACITY_45 = "eon-schwarz-opacity-45";
export const COLOR_SCHWARZ_OPACITY_50 = "eon-schwarz-opacity-50";
export const COLOR_SCHWARZ_OPACITY_55 = "eon-schwarz-opacity-55";
export const COLOR_SCHWARZ_OPACITY_60 = "eon-schwarz-opacity-60";
export const COLOR_SCHWARZ_OPACITY_65 = "eon-schwarz-opacity-65";
export const COLOR_SCHWARZ_OPACITY_70 = "eon-schwarz-opacity-70";
export const COLOR_SCHWARZ_OPACITY_75 = "eon-schwarz-opacity-75";
export const COLOR_SCHWARZ_OPACITY_80 = "eon-schwarz-opacity-80";
export const COLOR_SCHWARZ_OPACITY_85 = "eon-schwarz-opacity-85";
export const COLOR_SCHWARZ_OPACITY_90 = "eon-schwarz-opacity-90";
export const COLOR_SCHWARZ_OPACITY_95 = "eon-schwarz-opacity-95";
export const COLOR_ORIENTGELB_SHADE_1 = "eon-orientgelb-shade-1";
export const COLOR_ORIENTGELB_SHADE_2 = "eon-orientgelb-shade-2";
export const COLOR_ORIENTGELB_TINT_1 = "eon-orientgelb-tint-1";
export const COLOR_ORIENTGELB_TINT_2 = "eon-orientgelb-tint-2";
export const COLOR_ORIENTGELB_5 = "eon-orientgelb-5";
export const COLOR_ORIENTGELB_10 = "eon-orientgelb-10";
export const COLOR_ORIENTGELB_15 = "eon-orientgelb-15";
export const COLOR_ORIENTGELB_20 = "eon-orientgelb-20";
export const COLOR_ORIENTGELB_25 = "eon-orientgelb-25";
export const COLOR_ORIENTGELB_30 = "eon-orientgelb-30";
export const COLOR_ORIENTGELB_35 = "eon-orientgelb-35";
export const COLOR_ORIENTGELB_40 = "eon-orientgelb-40";
export const COLOR_ORIENTGELB_45 = "eon-orientgelb-45";
export const COLOR_ORIENTGELB_50 = "eon-orientgelb-50";
export const COLOR_ORIENTGELB_55 = "eon-orientgelb-55";
export const COLOR_ORIENTGELB_60 = "eon-orientgelb-60";
export const COLOR_ORIENTGELB_65 = "eon-orientgelb-65";
export const COLOR_ORIENTGELB_70 = "eon-orientgelb-70";
export const COLOR_ORIENTGELB_75 = "eon-orientgelb-75";
export const COLOR_ORIENTGELB_80 = "eon-orientgelb-80";
export const COLOR_ORIENTGELB_85 = "eon-orientgelb-85";
export const COLOR_ORIENTGELB_90 = "eon-orientgelb-90";
export const COLOR_ORIENTGELB_95 = "eon-orientgelb-95";
export const COLOR_ORIENTGELB_OPACITY_5 = "eon-orientgelb-opacity-5";
export const COLOR_ORIENTGELB_OPACITY_10 = "eon-orientgelb-opacity-10";
export const COLOR_ORIENTGELB_OPACITY_15 = "eon-orientgelb-opacity-15";
export const COLOR_ORIENTGELB_OPACITY_20 = "eon-orientgelb-opacity-20";
export const COLOR_ORIENTGELB_OPACITY_25 = "eon-orientgelb-opacity-25";
export const COLOR_ORIENTGELB_OPACITY_30 = "eon-orientgelb-opacity-30";
export const COLOR_ORIENTGELB_OPACITY_35 = "eon-orientgelb-opacity-35";
export const COLOR_ORIENTGELB_OPACITY_40 = "eon-orientgelb-opacity-40";
export const COLOR_ORIENTGELB_OPACITY_45 = "eon-orientgelb-opacity-45";
export const COLOR_ORIENTGELB_OPACITY_50 = "eon-orientgelb-opacity-50";
export const COLOR_ORIENTGELB_OPACITY_55 = "eon-orientgelb-opacity-55";
export const COLOR_ORIENTGELB_OPACITY_60 = "eon-orientgelb-opacity-60";
export const COLOR_ORIENTGELB_OPACITY_65 = "eon-orientgelb-opacity-65";
export const COLOR_ORIENTGELB_OPACITY_70 = "eon-orientgelb-opacity-70";
export const COLOR_ORIENTGELB_OPACITY_75 = "eon-orientgelb-opacity-75";
export const COLOR_ORIENTGELB_OPACITY_80 = "eon-orientgelb-opacity-80";
export const COLOR_ORIENTGELB_OPACITY_85 = "eon-orientgelb-opacity-85";
export const COLOR_ORIENTGELB_OPACITY_90 = "eon-orientgelb-opacity-90";
export const COLOR_ORIENTGELB_OPACITY_95 = "eon-orientgelb-opacity-95";
export const COLOR_FASERGRUEN_SHADE_1 = "eon-fasergruen-shade-1";
export const COLOR_FASERGRUEN_SHADE_2 = "eon-fasergruen-shade-2";
export const COLOR_FASERGRUEN_TINT_1 = "eon-fasergruen-tint-1";
export const COLOR_FASERGRUEN_TINT_2 = "eon-fasergruen-tint-2";
export const COLOR_FASERGRUEN_5 = "eon-fasergruen-5";
export const COLOR_FASERGRUEN_10 = "eon-fasergruen-10";
export const COLOR_FASERGRUEN_15 = "eon-fasergruen-15";
export const COLOR_FASERGRUEN_20 = "eon-fasergruen-20";
export const COLOR_FASERGRUEN_25 = "eon-fasergruen-25";
export const COLOR_FASERGRUEN_30 = "eon-fasergruen-30";
export const COLOR_FASERGRUEN_35 = "eon-fasergruen-35";
export const COLOR_FASERGRUEN_40 = "eon-fasergruen-40";
export const COLOR_FASERGRUEN_45 = "eon-fasergruen-45";
export const COLOR_FASERGRUEN_50 = "eon-fasergruen-50";
export const COLOR_FASERGRUEN_55 = "eon-fasergruen-55";
export const COLOR_FASERGRUEN_60 = "eon-fasergruen-60";
export const COLOR_FASERGRUEN_65 = "eon-fasergruen-65";
export const COLOR_FASERGRUEN_70 = "eon-fasergruen-70";
export const COLOR_FASERGRUEN_75 = "eon-fasergruen-75";
export const COLOR_FASERGRUEN_80 = "eon-fasergruen-80";
export const COLOR_FASERGRUEN_85 = "eon-fasergruen-85";
export const COLOR_FASERGRUEN_90 = "eon-fasergruen-90";
export const COLOR_FASERGRUEN_95 = "eon-fasergruen-95";
export const COLOR_FASERGRUEN_OPACITY_5 = "eon-fasergruen-opacity-5";
export const COLOR_FASERGRUEN_OPACITY_10 = "eon-fasergruen-opacity-10";
export const COLOR_FASERGRUEN_OPACITY_15 = "eon-fasergruen-opacity-15";
export const COLOR_FASERGRUEN_OPACITY_20 = "eon-fasergruen-opacity-20";
export const COLOR_FASERGRUEN_OPACITY_25 = "eon-fasergruen-opacity-25";
export const COLOR_FASERGRUEN_OPACITY_30 = "eon-fasergruen-opacity-30";
export const COLOR_FASERGRUEN_OPACITY_35 = "eon-fasergruen-opacity-35";
export const COLOR_FASERGRUEN_OPACITY_40 = "eon-fasergruen-opacity-40";
export const COLOR_FASERGRUEN_OPACITY_45 = "eon-fasergruen-opacity-45";
export const COLOR_FASERGRUEN_OPACITY_50 = "eon-fasergruen-opacity-50";
export const COLOR_FASERGRUEN_OPACITY_55 = "eon-fasergruen-opacity-55";
export const COLOR_FASERGRUEN_OPACITY_60 = "eon-fasergruen-opacity-60";
export const COLOR_FASERGRUEN_OPACITY_65 = "eon-fasergruen-opacity-65";
export const COLOR_FASERGRUEN_OPACITY_70 = "eon-fasergruen-opacity-70";
export const COLOR_FASERGRUEN_OPACITY_75 = "eon-fasergruen-opacity-75";
export const COLOR_FASERGRUEN_OPACITY_80 = "eon-fasergruen-opacity-80";
export const COLOR_FASERGRUEN_OPACITY_85 = "eon-fasergruen-opacity-85";
export const COLOR_FASERGRUEN_OPACITY_90 = "eon-fasergruen-opacity-90";
export const COLOR_FASERGRUEN_OPACITY_95 = "eon-fasergruen-opacity-95";
export const COLOR_ARKTISGRUEN_SHADE_1 = "eon-arktisgruen-shade-1";
export const COLOR_ARKTISGRUEN_SHADE_2 = "eon-arktisgruen-shade-2";
export const COLOR_ARKTISGRUEN_TINT_1 = "eon-arktisgruen-tint-1";
export const COLOR_ARKTISGRUEN_TINT_2 = "eon-arktisgruen-tint-2";
export const COLOR_ARKTISGRUEN_5 = "eon-arktisgruen-5";
export const COLOR_ARKTISGRUEN_10 = "eon-arktisgruen-10";
export const COLOR_ARKTISGRUEN_15 = "eon-arktisgruen-15";
export const COLOR_ARKTISGRUEN_20 = "eon-arktisgruen-20";
export const COLOR_ARKTISGRUEN_25 = "eon-arktisgruen-25";
export const COLOR_ARKTISGRUEN_30 = "eon-arktisgruen-30";
export const COLOR_ARKTISGRUEN_35 = "eon-arktisgruen-35";
export const COLOR_ARKTISGRUEN_40 = "eon-arktisgruen-40";
export const COLOR_ARKTISGRUEN_45 = "eon-arktisgruen-45";
export const COLOR_ARKTISGRUEN_50 = "eon-arktisgruen-50";
export const COLOR_ARKTISGRUEN_55 = "eon-arktisgruen-55";
export const COLOR_ARKTISGRUEN_60 = "eon-arktisgruen-60";
export const COLOR_ARKTISGRUEN_65 = "eon-arktisgruen-65";
export const COLOR_ARKTISGRUEN_70 = "eon-arktisgruen-70";
export const COLOR_ARKTISGRUEN_75 = "eon-arktisgruen-75";
export const COLOR_ARKTISGRUEN_80 = "eon-arktisgruen-80";
export const COLOR_ARKTISGRUEN_85 = "eon-arktisgruen-85";
export const COLOR_ARKTISGRUEN_90 = "eon-arktisgruen-90";
export const COLOR_ARKTISGRUEN_95 = "eon-arktisgruen-95";
export const COLOR_ARKTISGRUEN_OPACITY_5 = "eon-arktisgruen-opacity-5";
export const COLOR_ARKTISGRUEN_OPACITY_10 = "eon-arktisgruen-opacity-10";
export const COLOR_ARKTISGRUEN_OPACITY_15 = "eon-arktisgruen-opacity-15";
export const COLOR_ARKTISGRUEN_OPACITY_20 = "eon-arktisgruen-opacity-20";
export const COLOR_ARKTISGRUEN_OPACITY_25 = "eon-arktisgruen-opacity-25";
export const COLOR_ARKTISGRUEN_OPACITY_30 = "eon-arktisgruen-opacity-30";
export const COLOR_ARKTISGRUEN_OPACITY_35 = "eon-arktisgruen-opacity-35";
export const COLOR_ARKTISGRUEN_OPACITY_40 = "eon-arktisgruen-opacity-40";
export const COLOR_ARKTISGRUEN_OPACITY_45 = "eon-arktisgruen-opacity-45";
export const COLOR_ARKTISGRUEN_OPACITY_50 = "eon-arktisgruen-opacity-50";
export const COLOR_ARKTISGRUEN_OPACITY_55 = "eon-arktisgruen-opacity-55";
export const COLOR_ARKTISGRUEN_OPACITY_60 = "eon-arktisgruen-opacity-60";
export const COLOR_ARKTISGRUEN_OPACITY_65 = "eon-arktisgruen-opacity-65";
export const COLOR_ARKTISGRUEN_OPACITY_70 = "eon-arktisgruen-opacity-70";
export const COLOR_ARKTISGRUEN_OPACITY_75 = "eon-arktisgruen-opacity-75";
export const COLOR_ARKTISGRUEN_OPACITY_80 = "eon-arktisgruen-opacity-80";
export const COLOR_ARKTISGRUEN_OPACITY_85 = "eon-arktisgruen-opacity-85";
export const COLOR_ARKTISGRUEN_OPACITY_90 = "eon-arktisgruen-opacity-90";
export const COLOR_ARKTISGRUEN_OPACITY_95 = "eon-arktisgruen-opacity-95";
export const COLOR_KARIBIKBLAU_SHADE_1 = "eon-karibikblau-shade-1";
export const COLOR_KARIBIKBLAU_SHADE_2 = "eon-karibikblau-shade-2";
export const COLOR_KARIBIKBLAU_TINT_1 = "eon-karibikblau-tint-1";
export const COLOR_KARIBIKBLAU_TINT_2 = "eon-karibikblau-tint-2";
export const COLOR_KARIBIKBLAU_5 = "eon-karibikblau-5";
export const COLOR_KARIBIKBLAU_10 = "eon-karibikblau-10";
export const COLOR_KARIBIKBLAU_15 = "eon-karibikblau-15";
export const COLOR_KARIBIKBLAU_20 = "eon-karibikblau-20";
export const COLOR_KARIBIKBLAU_25 = "eon-karibikblau-25";
export const COLOR_KARIBIKBLAU_30 = "eon-karibikblau-30";
export const COLOR_KARIBIKBLAU_35 = "eon-karibikblau-35";
export const COLOR_KARIBIKBLAU_40 = "eon-karibikblau-40";
export const COLOR_KARIBIKBLAU_45 = "eon-karibikblau-45";
export const COLOR_KARIBIKBLAU_50 = "eon-karibikblau-50";
export const COLOR_KARIBIKBLAU_55 = "eon-karibikblau-55";
export const COLOR_KARIBIKBLAU_60 = "eon-karibikblau-60";
export const COLOR_KARIBIKBLAU_65 = "eon-karibikblau-65";
export const COLOR_KARIBIKBLAU_70 = "eon-karibikblau-70";
export const COLOR_KARIBIKBLAU_75 = "eon-karibikblau-75";
export const COLOR_KARIBIKBLAU_80 = "eon-karibikblau-80";
export const COLOR_KARIBIKBLAU_85 = "eon-karibikblau-85";
export const COLOR_KARIBIKBLAU_90 = "eon-karibikblau-90";
export const COLOR_KARIBIKBLAU_95 = "eon-karibikblau-95";
export const COLOR_KARIBIKBLAU_OPACITY_5 = "eon-karibikblau-opacity-5";
export const COLOR_KARIBIKBLAU_OPACITY_10 = "eon-karibikblau-opacity-10";
export const COLOR_KARIBIKBLAU_OPACITY_15 = "eon-karibikblau-opacity-15";
export const COLOR_KARIBIKBLAU_OPACITY_20 = "eon-karibikblau-opacity-20";
export const COLOR_KARIBIKBLAU_OPACITY_25 = "eon-karibikblau-opacity-25";
export const COLOR_KARIBIKBLAU_OPACITY_30 = "eon-karibikblau-opacity-30";
export const COLOR_KARIBIKBLAU_OPACITY_35 = "eon-karibikblau-opacity-35";
export const COLOR_KARIBIKBLAU_OPACITY_40 = "eon-karibikblau-opacity-40";
export const COLOR_KARIBIKBLAU_OPACITY_45 = "eon-karibikblau-opacity-45";
export const COLOR_KARIBIKBLAU_OPACITY_50 = "eon-karibikblau-opacity-50";
export const COLOR_KARIBIKBLAU_OPACITY_55 = "eon-karibikblau-opacity-55";
export const COLOR_KARIBIKBLAU_OPACITY_60 = "eon-karibikblau-opacity-60";
export const COLOR_KARIBIKBLAU_OPACITY_65 = "eon-karibikblau-opacity-65";
export const COLOR_KARIBIKBLAU_OPACITY_70 = "eon-karibikblau-opacity-70";
export const COLOR_KARIBIKBLAU_OPACITY_75 = "eon-karibikblau-opacity-75";
export const COLOR_KARIBIKBLAU_OPACITY_80 = "eon-karibikblau-opacity-80";
export const COLOR_KARIBIKBLAU_OPACITY_85 = "eon-karibikblau-opacity-85";
export const COLOR_KARIBIKBLAU_OPACITY_90 = "eon-karibikblau-opacity-90";
export const COLOR_KARIBIKBLAU_OPACITY_95 = "eon-karibikblau-opacity-95";
export const COLOR_BISCHOFSROT_SHADE_1 = "eon-bischofsrot-shade-1";
export const COLOR_BISCHOFSROT_SHADE_2 = "eon-bischofsrot-shade-2";
export const COLOR_BISCHOFSROT_TINT_1 = "eon-bischofsrot-tint-1";
export const COLOR_BISCHOFSROT_TINT_2 = "eon-bischofsrot-tint-2";
export const COLOR_BISCHOFSROT_5 = "eon-bischofsrot-5";
export const COLOR_BISCHOFSROT_10 = "eon-bischofsrot-10";
export const COLOR_BISCHOFSROT_15 = "eon-bischofsrot-15";
export const COLOR_BISCHOFSROT_20 = "eon-bischofsrot-20";
export const COLOR_BISCHOFSROT_25 = "eon-bischofsrot-25";
export const COLOR_BISCHOFSROT_30 = "eon-bischofsrot-30";
export const COLOR_BISCHOFSROT_35 = "eon-bischofsrot-35";
export const COLOR_BISCHOFSROT_40 = "eon-bischofsrot-40";
export const COLOR_BISCHOFSROT_45 = "eon-bischofsrot-45";
export const COLOR_BISCHOFSROT_50 = "eon-bischofsrot-50";
export const COLOR_BISCHOFSROT_55 = "eon-bischofsrot-55";
export const COLOR_BISCHOFSROT_60 = "eon-bischofsrot-60";
export const COLOR_BISCHOFSROT_65 = "eon-bischofsrot-65";
export const COLOR_BISCHOFSROT_70 = "eon-bischofsrot-70";
export const COLOR_BISCHOFSROT_75 = "eon-bischofsrot-75";
export const COLOR_BISCHOFSROT_80 = "eon-bischofsrot-80";
export const COLOR_BISCHOFSROT_85 = "eon-bischofsrot-85";
export const COLOR_BISCHOFSROT_90 = "eon-bischofsrot-90";
export const COLOR_BISCHOFSROT_95 = "eon-bischofsrot-95";
export const COLOR_BISCHOFSROT_OPACITY_5 = "eon-bischofsrot-opacity-5";
export const COLOR_BISCHOFSROT_OPACITY_10 = "eon-bischofsrot-opacity-10";
export const COLOR_BISCHOFSROT_OPACITY_15 = "eon-bischofsrot-opacity-15";
export const COLOR_BISCHOFSROT_OPACITY_20 = "eon-bischofsrot-opacity-20";
export const COLOR_BISCHOFSROT_OPACITY_25 = "eon-bischofsrot-opacity-25";
export const COLOR_BISCHOFSROT_OPACITY_30 = "eon-bischofsrot-opacity-30";
export const COLOR_BISCHOFSROT_OPACITY_35 = "eon-bischofsrot-opacity-35";
export const COLOR_BISCHOFSROT_OPACITY_40 = "eon-bischofsrot-opacity-40";
export const COLOR_BISCHOFSROT_OPACITY_45 = "eon-bischofsrot-opacity-45";
export const COLOR_BISCHOFSROT_OPACITY_50 = "eon-bischofsrot-opacity-50";
export const COLOR_BISCHOFSROT_OPACITY_55 = "eon-bischofsrot-opacity-55";
export const COLOR_BISCHOFSROT_OPACITY_60 = "eon-bischofsrot-opacity-60";
export const COLOR_BISCHOFSROT_OPACITY_65 = "eon-bischofsrot-opacity-65";
export const COLOR_BISCHOFSROT_OPACITY_70 = "eon-bischofsrot-opacity-70";
export const COLOR_BISCHOFSROT_OPACITY_75 = "eon-bischofsrot-opacity-75";
export const COLOR_BISCHOFSROT_OPACITY_80 = "eon-bischofsrot-opacity-80";
export const COLOR_BISCHOFSROT_OPACITY_85 = "eon-bischofsrot-opacity-85";
export const COLOR_BISCHOFSROT_OPACITY_90 = "eon-bischofsrot-opacity-90";
export const COLOR_BISCHOFSROT_OPACITY_95 = "eon-bischofsrot-opacity-95";
export const COLOR_ALTROSA_SHADE_1 = "eon-altrosa-shade-1";
export const COLOR_ALTROSA_SHADE_2 = "eon-altrosa-shade-2";
export const COLOR_ALTROSA_TINT_1 = "eon-altrosa-tint-1";
export const COLOR_ALTROSA_TINT_2 = "eon-altrosa-tint-2";
export const COLOR_ALTROSA_5 = "eon-altrosa-5";
export const COLOR_ALTROSA_10 = "eon-altrosa-10";
export const COLOR_ALTROSA_15 = "eon-altrosa-15";
export const COLOR_ALTROSA_20 = "eon-altrosa-20";
export const COLOR_ALTROSA_25 = "eon-altrosa-25";
export const COLOR_ALTROSA_30 = "eon-altrosa-30";
export const COLOR_ALTROSA_35 = "eon-altrosa-35";
export const COLOR_ALTROSA_40 = "eon-altrosa-40";
export const COLOR_ALTROSA_45 = "eon-altrosa-45";
export const COLOR_ALTROSA_50 = "eon-altrosa-50";
export const COLOR_ALTROSA_55 = "eon-altrosa-55";
export const COLOR_ALTROSA_60 = "eon-altrosa-60";
export const COLOR_ALTROSA_65 = "eon-altrosa-65";
export const COLOR_ALTROSA_70 = "eon-altrosa-70";
export const COLOR_ALTROSA_75 = "eon-altrosa-75";
export const COLOR_ALTROSA_80 = "eon-altrosa-80";
export const COLOR_ALTROSA_85 = "eon-altrosa-85";
export const COLOR_ALTROSA_90 = "eon-altrosa-90";
export const COLOR_ALTROSA_95 = "eon-altrosa-95";
export const COLOR_ALTROSA_OPACITY_5 = "eon-altrosa-opacity-5";
export const COLOR_ALTROSA_OPACITY_10 = "eon-altrosa-opacity-10";
export const COLOR_ALTROSA_OPACITY_15 = "eon-altrosa-opacity-15";
export const COLOR_ALTROSA_OPACITY_20 = "eon-altrosa-opacity-20";
export const COLOR_ALTROSA_OPACITY_25 = "eon-altrosa-opacity-25";
export const COLOR_ALTROSA_OPACITY_30 = "eon-altrosa-opacity-30";
export const COLOR_ALTROSA_OPACITY_35 = "eon-altrosa-opacity-35";
export const COLOR_ALTROSA_OPACITY_40 = "eon-altrosa-opacity-40";
export const COLOR_ALTROSA_OPACITY_45 = "eon-altrosa-opacity-45";
export const COLOR_ALTROSA_OPACITY_50 = "eon-altrosa-opacity-50";
export const COLOR_ALTROSA_OPACITY_55 = "eon-altrosa-opacity-55";
export const COLOR_ALTROSA_OPACITY_60 = "eon-altrosa-opacity-60";
export const COLOR_ALTROSA_OPACITY_65 = "eon-altrosa-opacity-65";
export const COLOR_ALTROSA_OPACITY_70 = "eon-altrosa-opacity-70";
export const COLOR_ALTROSA_OPACITY_75 = "eon-altrosa-opacity-75";
export const COLOR_ALTROSA_OPACITY_80 = "eon-altrosa-opacity-80";
export const COLOR_ALTROSA_OPACITY_85 = "eon-altrosa-opacity-85";
export const COLOR_ALTROSA_OPACITY_90 = "eon-altrosa-opacity-90";
export const COLOR_ALTROSA_OPACITY_95 = "eon-altrosa-opacity-95";
export const COLOR_KERZENGELB_SHADE_1 = "eon-kerzengelb-shade-1";
export const COLOR_KERZENGELB_SHADE_2 = "eon-kerzengelb-shade-2";
export const COLOR_KERZENGELB_TINT_1 = "eon-kerzengelb-tint-1";
export const COLOR_KERZENGELB_TINT_2 = "eon-kerzengelb-tint-2";
export const COLOR_KERZENGELB_5 = "eon-kerzengelb-5";
export const COLOR_KERZENGELB_10 = "eon-kerzengelb-10";
export const COLOR_KERZENGELB_15 = "eon-kerzengelb-15";
export const COLOR_KERZENGELB_20 = "eon-kerzengelb-20";
export const COLOR_KERZENGELB_25 = "eon-kerzengelb-25";
export const COLOR_KERZENGELB_30 = "eon-kerzengelb-30";
export const COLOR_KERZENGELB_35 = "eon-kerzengelb-35";
export const COLOR_KERZENGELB_40 = "eon-kerzengelb-40";
export const COLOR_KERZENGELB_45 = "eon-kerzengelb-45";
export const COLOR_KERZENGELB_50 = "eon-kerzengelb-50";
export const COLOR_KERZENGELB_55 = "eon-kerzengelb-55";
export const COLOR_KERZENGELB_60 = "eon-kerzengelb-60";
export const COLOR_KERZENGELB_65 = "eon-kerzengelb-65";
export const COLOR_KERZENGELB_70 = "eon-kerzengelb-70";
export const COLOR_KERZENGELB_75 = "eon-kerzengelb-75";
export const COLOR_KERZENGELB_80 = "eon-kerzengelb-80";
export const COLOR_KERZENGELB_85 = "eon-kerzengelb-85";
export const COLOR_KERZENGELB_90 = "eon-kerzengelb-90";
export const COLOR_KERZENGELB_95 = "eon-kerzengelb-95";
export const COLOR_KERZENGELB_OPACITY_5 = "eon-kerzengelb-opacity-5";
export const COLOR_KERZENGELB_OPACITY_10 = "eon-kerzengelb-opacity-10";
export const COLOR_KERZENGELB_OPACITY_15 = "eon-kerzengelb-opacity-15";
export const COLOR_KERZENGELB_OPACITY_20 = "eon-kerzengelb-opacity-20";
export const COLOR_KERZENGELB_OPACITY_25 = "eon-kerzengelb-opacity-25";
export const COLOR_KERZENGELB_OPACITY_30 = "eon-kerzengelb-opacity-30";
export const COLOR_KERZENGELB_OPACITY_35 = "eon-kerzengelb-opacity-35";
export const COLOR_KERZENGELB_OPACITY_40 = "eon-kerzengelb-opacity-40";
export const COLOR_KERZENGELB_OPACITY_45 = "eon-kerzengelb-opacity-45";
export const COLOR_KERZENGELB_OPACITY_50 = "eon-kerzengelb-opacity-50";
export const COLOR_KERZENGELB_OPACITY_55 = "eon-kerzengelb-opacity-55";
export const COLOR_KERZENGELB_OPACITY_60 = "eon-kerzengelb-opacity-60";
export const COLOR_KERZENGELB_OPACITY_65 = "eon-kerzengelb-opacity-65";
export const COLOR_KERZENGELB_OPACITY_70 = "eon-kerzengelb-opacity-70";
export const COLOR_KERZENGELB_OPACITY_75 = "eon-kerzengelb-opacity-75";
export const COLOR_KERZENGELB_OPACITY_80 = "eon-kerzengelb-opacity-80";
export const COLOR_KERZENGELB_OPACITY_85 = "eon-kerzengelb-opacity-85";
export const COLOR_KERZENGELB_OPACITY_90 = "eon-kerzengelb-opacity-90";
export const COLOR_KERZENGELB_OPACITY_95 = "eon-kerzengelb-opacity-95";
export const COLOR_BRILLANTKARMIN_SHADE_1 = "eon-brillantkarmin-shade-1";
export const COLOR_BRILLANTKARMIN_SHADE_2 = "eon-brillantkarmin-shade-2";
export const COLOR_BRILLANTKARMIN_TINT_1 = "eon-brillantkarmin-tint-1";
export const COLOR_BRILLANTKARMIN_TINT_2 = "eon-brillantkarmin-tint-2";
export const COLOR_BRILLANTKARMIN_5 = "eon-brillantkarmin-5";
export const COLOR_BRILLANTKARMIN_10 = "eon-brillantkarmin-10";
export const COLOR_BRILLANTKARMIN_15 = "eon-brillantkarmin-15";
export const COLOR_BRILLANTKARMIN_20 = "eon-brillantkarmin-20";
export const COLOR_BRILLANTKARMIN_25 = "eon-brillantkarmin-25";
export const COLOR_BRILLANTKARMIN_30 = "eon-brillantkarmin-30";
export const COLOR_BRILLANTKARMIN_35 = "eon-brillantkarmin-35";
export const COLOR_BRILLANTKARMIN_40 = "eon-brillantkarmin-40";
export const COLOR_BRILLANTKARMIN_45 = "eon-brillantkarmin-45";
export const COLOR_BRILLANTKARMIN_50 = "eon-brillantkarmin-50";
export const COLOR_BRILLANTKARMIN_55 = "eon-brillantkarmin-55";
export const COLOR_BRILLANTKARMIN_60 = "eon-brillantkarmin-60";
export const COLOR_BRILLANTKARMIN_65 = "eon-brillantkarmin-65";
export const COLOR_BRILLANTKARMIN_70 = "eon-brillantkarmin-70";
export const COLOR_BRILLANTKARMIN_75 = "eon-brillantkarmin-75";
export const COLOR_BRILLANTKARMIN_80 = "eon-brillantkarmin-80";
export const COLOR_BRILLANTKARMIN_85 = "eon-brillantkarmin-85";
export const COLOR_BRILLANTKARMIN_90 = "eon-brillantkarmin-90";
export const COLOR_BRILLANTKARMIN_95 = "eon-brillantkarmin-95";
export const COLOR_BRILLANTKARMIN_OPACITY_5 = "eon-brillantkarmin-opacity-5";
export const COLOR_BRILLANTKARMIN_OPACITY_10 = "eon-brillantkarmin-opacity-10";
export const COLOR_BRILLANTKARMIN_OPACITY_15 = "eon-brillantkarmin-opacity-15";
export const COLOR_BRILLANTKARMIN_OPACITY_20 = "eon-brillantkarmin-opacity-20";
export const COLOR_BRILLANTKARMIN_OPACITY_25 = "eon-brillantkarmin-opacity-25";
export const COLOR_BRILLANTKARMIN_OPACITY_30 = "eon-brillantkarmin-opacity-30";
export const COLOR_BRILLANTKARMIN_OPACITY_35 = "eon-brillantkarmin-opacity-35";
export const COLOR_BRILLANTKARMIN_OPACITY_40 = "eon-brillantkarmin-opacity-40";
export const COLOR_BRILLANTKARMIN_OPACITY_45 = "eon-brillantkarmin-opacity-45";
export const COLOR_BRILLANTKARMIN_OPACITY_50 = "eon-brillantkarmin-opacity-50";
export const COLOR_BRILLANTKARMIN_OPACITY_55 = "eon-brillantkarmin-opacity-55";
export const COLOR_BRILLANTKARMIN_OPACITY_60 = "eon-brillantkarmin-opacity-60";
export const COLOR_BRILLANTKARMIN_OPACITY_65 = "eon-brillantkarmin-opacity-65";
export const COLOR_BRILLANTKARMIN_OPACITY_70 = "eon-brillantkarmin-opacity-70";
export const COLOR_BRILLANTKARMIN_OPACITY_75 = "eon-brillantkarmin-opacity-75";
export const COLOR_BRILLANTKARMIN_OPACITY_80 = "eon-brillantkarmin-opacity-80";
export const COLOR_BRILLANTKARMIN_OPACITY_85 = "eon-brillantkarmin-opacity-85";
export const COLOR_BRILLANTKARMIN_OPACITY_90 = "eon-brillantkarmin-opacity-90";
export const COLOR_BRILLANTKARMIN_OPACITY_95 = "eon-brillantkarmin-opacity-95";
export const COLOR_ERDBEERROT_SHADE_1 = "eon-erdbeerrot-shade-1";
export const COLOR_ERDBEERROT_SHADE_2 = "eon-erdbeerrot-shade-2";
export const COLOR_ERDBEERROT_TINT_1 = "eon-erdbeerrot-tint-1";
export const COLOR_ERDBEERROT_TINT_2 = "eon-erdbeerrot-tint-2";
export const COLOR_ERDBEERROT_5 = "eon-erdbeerrot-5";
export const COLOR_ERDBEERROT_10 = "eon-erdbeerrot-10";
export const COLOR_ERDBEERROT_15 = "eon-erdbeerrot-15";
export const COLOR_ERDBEERROT_20 = "eon-erdbeerrot-20";
export const COLOR_ERDBEERROT_25 = "eon-erdbeerrot-25";
export const COLOR_ERDBEERROT_30 = "eon-erdbeerrot-30";
export const COLOR_ERDBEERROT_35 = "eon-erdbeerrot-35";
export const COLOR_ERDBEERROT_40 = "eon-erdbeerrot-40";
export const COLOR_ERDBEERROT_45 = "eon-erdbeerrot-45";
export const COLOR_ERDBEERROT_50 = "eon-erdbeerrot-50";
export const COLOR_ERDBEERROT_55 = "eon-erdbeerrot-55";
export const COLOR_ERDBEERROT_60 = "eon-erdbeerrot-60";
export const COLOR_ERDBEERROT_65 = "eon-erdbeerrot-65";
export const COLOR_ERDBEERROT_70 = "eon-erdbeerrot-70";
export const COLOR_ERDBEERROT_75 = "eon-erdbeerrot-75";
export const COLOR_ERDBEERROT_80 = "eon-erdbeerrot-80";
export const COLOR_ERDBEERROT_85 = "eon-erdbeerrot-85";
export const COLOR_ERDBEERROT_90 = "eon-erdbeerrot-90";
export const COLOR_ERDBEERROT_95 = "eon-erdbeerrot-95";
export const COLOR_ERDBEERROT_OPACITY_5 = "eon-erdbeerrot-opacity-5";
export const COLOR_ERDBEERROT_OPACITY_10 = "eon-erdbeerrot-opacity-10";
export const COLOR_ERDBEERROT_OPACITY_15 = "eon-erdbeerrot-opacity-15";
export const COLOR_ERDBEERROT_OPACITY_20 = "eon-erdbeerrot-opacity-20";
export const COLOR_ERDBEERROT_OPACITY_25 = "eon-erdbeerrot-opacity-25";
export const COLOR_ERDBEERROT_OPACITY_30 = "eon-erdbeerrot-opacity-30";
export const COLOR_ERDBEERROT_OPACITY_35 = "eon-erdbeerrot-opacity-35";
export const COLOR_ERDBEERROT_OPACITY_40 = "eon-erdbeerrot-opacity-40";
export const COLOR_ERDBEERROT_OPACITY_45 = "eon-erdbeerrot-opacity-45";
export const COLOR_ERDBEERROT_OPACITY_50 = "eon-erdbeerrot-opacity-50";
export const COLOR_ERDBEERROT_OPACITY_55 = "eon-erdbeerrot-opacity-55";
export const COLOR_ERDBEERROT_OPACITY_60 = "eon-erdbeerrot-opacity-60";
export const COLOR_ERDBEERROT_OPACITY_65 = "eon-erdbeerrot-opacity-65";
export const COLOR_ERDBEERROT_OPACITY_70 = "eon-erdbeerrot-opacity-70";
export const COLOR_ERDBEERROT_OPACITY_75 = "eon-erdbeerrot-opacity-75";
export const COLOR_ERDBEERROT_OPACITY_80 = "eon-erdbeerrot-opacity-80";
export const COLOR_ERDBEERROT_OPACITY_85 = "eon-erdbeerrot-opacity-85";
export const COLOR_ERDBEERROT_OPACITY_90 = "eon-erdbeerrot-opacity-90";
export const COLOR_ERDBEERROT_OPACITY_95 = "eon-erdbeerrot-opacity-95";
export const COLOR_VERKEHRSORANGE_SHADE_1 = "eon-verkehrsorange-shade-1";
export const COLOR_VERKEHRSORANGE_SHADE_2 = "eon-verkehrsorange-shade-2";
export const COLOR_VERKEHRSORANGE_TINT_1 = "eon-verkehrsorange-tint-1";
export const COLOR_VERKEHRSORANGE_TINT_2 = "eon-verkehrsorange-tint-2";
export const COLOR_VERKEHRSORANGE_5 = "eon-verkehrsorange-5";
export const COLOR_VERKEHRSORANGE_10 = "eon-verkehrsorange-10";
export const COLOR_VERKEHRSORANGE_15 = "eon-verkehrsorange-15";
export const COLOR_VERKEHRSORANGE_20 = "eon-verkehrsorange-20";
export const COLOR_VERKEHRSORANGE_25 = "eon-verkehrsorange-25";
export const COLOR_VERKEHRSORANGE_30 = "eon-verkehrsorange-30";
export const COLOR_VERKEHRSORANGE_35 = "eon-verkehrsorange-35";
export const COLOR_VERKEHRSORANGE_40 = "eon-verkehrsorange-40";
export const COLOR_VERKEHRSORANGE_45 = "eon-verkehrsorange-45";
export const COLOR_VERKEHRSORANGE_50 = "eon-verkehrsorange-50";
export const COLOR_VERKEHRSORANGE_55 = "eon-verkehrsorange-55";
export const COLOR_VERKEHRSORANGE_60 = "eon-verkehrsorange-60";
export const COLOR_VERKEHRSORANGE_65 = "eon-verkehrsorange-65";
export const COLOR_VERKEHRSORANGE_70 = "eon-verkehrsorange-70";
export const COLOR_VERKEHRSORANGE_75 = "eon-verkehrsorange-75";
export const COLOR_VERKEHRSORANGE_80 = "eon-verkehrsorange-80";
export const COLOR_VERKEHRSORANGE_85 = "eon-verkehrsorange-85";
export const COLOR_VERKEHRSORANGE_90 = "eon-verkehrsorange-90";
export const COLOR_VERKEHRSORANGE_95 = "eon-verkehrsorange-95";
export const COLOR_VERKEHRSORANGE_OPACITY_5 = "eon-verkehrsorange-opacity-5";
export const COLOR_VERKEHRSORANGE_OPACITY_10 = "eon-verkehrsorange-opacity-10";
export const COLOR_VERKEHRSORANGE_OPACITY_15 = "eon-verkehrsorange-opacity-15";
export const COLOR_VERKEHRSORANGE_OPACITY_20 = "eon-verkehrsorange-opacity-20";
export const COLOR_VERKEHRSORANGE_OPACITY_25 = "eon-verkehrsorange-opacity-25";
export const COLOR_VERKEHRSORANGE_OPACITY_30 = "eon-verkehrsorange-opacity-30";
export const COLOR_VERKEHRSORANGE_OPACITY_35 = "eon-verkehrsorange-opacity-35";
export const COLOR_VERKEHRSORANGE_OPACITY_40 = "eon-verkehrsorange-opacity-40";
export const COLOR_VERKEHRSORANGE_OPACITY_45 = "eon-verkehrsorange-opacity-45";
export const COLOR_VERKEHRSORANGE_OPACITY_50 = "eon-verkehrsorange-opacity-50";
export const COLOR_VERKEHRSORANGE_OPACITY_55 = "eon-verkehrsorange-opacity-55";
export const COLOR_VERKEHRSORANGE_OPACITY_60 = "eon-verkehrsorange-opacity-60";
export const COLOR_VERKEHRSORANGE_OPACITY_65 = "eon-verkehrsorange-opacity-65";
export const COLOR_VERKEHRSORANGE_OPACITY_70 = "eon-verkehrsorange-opacity-70";
export const COLOR_VERKEHRSORANGE_OPACITY_75 = "eon-verkehrsorange-opacity-75";
export const COLOR_VERKEHRSORANGE_OPACITY_80 = "eon-verkehrsorange-opacity-80";
export const COLOR_VERKEHRSORANGE_OPACITY_85 = "eon-verkehrsorange-opacity-85";
export const COLOR_VERKEHRSORANGE_OPACITY_90 = "eon-verkehrsorange-opacity-90";
export const COLOR_VERKEHRSORANGE_OPACITY_95 = "eon-verkehrsorange-opacity-95";
export const COLOR_DAHLIENGELB_SHADE_1 = "eon-dahliengelb-shade-1";
export const COLOR_DAHLIENGELB_SHADE_2 = "eon-dahliengelb-shade-2";
export const COLOR_DAHLIENGELB_TINT_1 = "eon-dahliengelb-tint-1";
export const COLOR_DAHLIENGELB_TINT_2 = "eon-dahliengelb-tint-2";
export const COLOR_DAHLIENGELB_5 = "eon-dahliengelb-5";
export const COLOR_DAHLIENGELB_10 = "eon-dahliengelb-10";
export const COLOR_DAHLIENGELB_15 = "eon-dahliengelb-15";
export const COLOR_DAHLIENGELB_20 = "eon-dahliengelb-20";
export const COLOR_DAHLIENGELB_25 = "eon-dahliengelb-25";
export const COLOR_DAHLIENGELB_30 = "eon-dahliengelb-30";
export const COLOR_DAHLIENGELB_35 = "eon-dahliengelb-35";
export const COLOR_DAHLIENGELB_40 = "eon-dahliengelb-40";
export const COLOR_DAHLIENGELB_45 = "eon-dahliengelb-45";
export const COLOR_DAHLIENGELB_50 = "eon-dahliengelb-50";
export const COLOR_DAHLIENGELB_55 = "eon-dahliengelb-55";
export const COLOR_DAHLIENGELB_60 = "eon-dahliengelb-60";
export const COLOR_DAHLIENGELB_65 = "eon-dahliengelb-65";
export const COLOR_DAHLIENGELB_70 = "eon-dahliengelb-70";
export const COLOR_DAHLIENGELB_75 = "eon-dahliengelb-75";
export const COLOR_DAHLIENGELB_80 = "eon-dahliengelb-80";
export const COLOR_DAHLIENGELB_85 = "eon-dahliengelb-85";
export const COLOR_DAHLIENGELB_90 = "eon-dahliengelb-90";
export const COLOR_DAHLIENGELB_95 = "eon-dahliengelb-95";
export const COLOR_DAHLIENGELB_OPACITY_5 = "eon-dahliengelb-opacity-5";
export const COLOR_DAHLIENGELB_OPACITY_10 = "eon-dahliengelb-opacity-10";
export const COLOR_DAHLIENGELB_OPACITY_15 = "eon-dahliengelb-opacity-15";
export const COLOR_DAHLIENGELB_OPACITY_20 = "eon-dahliengelb-opacity-20";
export const COLOR_DAHLIENGELB_OPACITY_25 = "eon-dahliengelb-opacity-25";
export const COLOR_DAHLIENGELB_OPACITY_30 = "eon-dahliengelb-opacity-30";
export const COLOR_DAHLIENGELB_OPACITY_35 = "eon-dahliengelb-opacity-35";
export const COLOR_DAHLIENGELB_OPACITY_40 = "eon-dahliengelb-opacity-40";
export const COLOR_DAHLIENGELB_OPACITY_45 = "eon-dahliengelb-opacity-45";
export const COLOR_DAHLIENGELB_OPACITY_50 = "eon-dahliengelb-opacity-50";
export const COLOR_DAHLIENGELB_OPACITY_55 = "eon-dahliengelb-opacity-55";
export const COLOR_DAHLIENGELB_OPACITY_60 = "eon-dahliengelb-opacity-60";
export const COLOR_DAHLIENGELB_OPACITY_65 = "eon-dahliengelb-opacity-65";
export const COLOR_DAHLIENGELB_OPACITY_70 = "eon-dahliengelb-opacity-70";
export const COLOR_DAHLIENGELB_OPACITY_75 = "eon-dahliengelb-opacity-75";
export const COLOR_DAHLIENGELB_OPACITY_80 = "eon-dahliengelb-opacity-80";
export const COLOR_DAHLIENGELB_OPACITY_85 = "eon-dahliengelb-opacity-85";
export const COLOR_DAHLIENGELB_OPACITY_90 = "eon-dahliengelb-opacity-90";
export const COLOR_DAHLIENGELB_OPACITY_95 = "eon-dahliengelb-opacity-95";
export const COLOR_LEUCHTENDGRUEN_SHADE_1 = "eon-leuchtendgruen-shade-1";
export const COLOR_LEUCHTENDGRUEN_SHADE_2 = "eon-leuchtendgruen-shade-2";
export const COLOR_LEUCHTENDGRUEN_TINT_1 = "eon-leuchtendgruen-tint-1";
export const COLOR_LEUCHTENDGRUEN_TINT_2 = "eon-leuchtendgruen-tint-2";
export const COLOR_LEUCHTENDGRUEN_5 = "eon-leuchtendgruen-5";
export const COLOR_LEUCHTENDGRUEN_10 = "eon-leuchtendgruen-10";
export const COLOR_LEUCHTENDGRUEN_15 = "eon-leuchtendgruen-15";
export const COLOR_LEUCHTENDGRUEN_20 = "eon-leuchtendgruen-20";
export const COLOR_LEUCHTENDGRUEN_25 = "eon-leuchtendgruen-25";
export const COLOR_LEUCHTENDGRUEN_30 = "eon-leuchtendgruen-30";
export const COLOR_LEUCHTENDGRUEN_35 = "eon-leuchtendgruen-35";
export const COLOR_LEUCHTENDGRUEN_40 = "eon-leuchtendgruen-40";
export const COLOR_LEUCHTENDGRUEN_45 = "eon-leuchtendgruen-45";
export const COLOR_LEUCHTENDGRUEN_50 = "eon-leuchtendgruen-50";
export const COLOR_LEUCHTENDGRUEN_55 = "eon-leuchtendgruen-55";
export const COLOR_LEUCHTENDGRUEN_60 = "eon-leuchtendgruen-60";
export const COLOR_LEUCHTENDGRUEN_65 = "eon-leuchtendgruen-65";
export const COLOR_LEUCHTENDGRUEN_70 = "eon-leuchtendgruen-70";
export const COLOR_LEUCHTENDGRUEN_75 = "eon-leuchtendgruen-75";
export const COLOR_LEUCHTENDGRUEN_80 = "eon-leuchtendgruen-80";
export const COLOR_LEUCHTENDGRUEN_85 = "eon-leuchtendgruen-85";
export const COLOR_LEUCHTENDGRUEN_90 = "eon-leuchtendgruen-90";
export const COLOR_LEUCHTENDGRUEN_95 = "eon-leuchtendgruen-95";
export const COLOR_LEUCHTENDGRUEN_OPACITY_5 = "eon-leuchtendgruen-opacity-5";
export const COLOR_LEUCHTENDGRUEN_OPACITY_10 = "eon-leuchtendgruen-opacity-10";
export const COLOR_LEUCHTENDGRUEN_OPACITY_15 = "eon-leuchtendgruen-opacity-15";
export const COLOR_LEUCHTENDGRUEN_OPACITY_20 = "eon-leuchtendgruen-opacity-20";
export const COLOR_LEUCHTENDGRUEN_OPACITY_25 = "eon-leuchtendgruen-opacity-25";
export const COLOR_LEUCHTENDGRUEN_OPACITY_30 = "eon-leuchtendgruen-opacity-30";
export const COLOR_LEUCHTENDGRUEN_OPACITY_35 = "eon-leuchtendgruen-opacity-35";
export const COLOR_LEUCHTENDGRUEN_OPACITY_40 = "eon-leuchtendgruen-opacity-40";
export const COLOR_LEUCHTENDGRUEN_OPACITY_45 = "eon-leuchtendgruen-opacity-45";
export const COLOR_LEUCHTENDGRUEN_OPACITY_50 = "eon-leuchtendgruen-opacity-50";
export const COLOR_LEUCHTENDGRUEN_OPACITY_55 = "eon-leuchtendgruen-opacity-55";
export const COLOR_LEUCHTENDGRUEN_OPACITY_60 = "eon-leuchtendgruen-opacity-60";
export const COLOR_LEUCHTENDGRUEN_OPACITY_65 = "eon-leuchtendgruen-opacity-65";
export const COLOR_LEUCHTENDGRUEN_OPACITY_70 = "eon-leuchtendgruen-opacity-70";
export const COLOR_LEUCHTENDGRUEN_OPACITY_75 = "eon-leuchtendgruen-opacity-75";
export const COLOR_LEUCHTENDGRUEN_OPACITY_80 = "eon-leuchtendgruen-opacity-80";
export const COLOR_LEUCHTENDGRUEN_OPACITY_85 = "eon-leuchtendgruen-opacity-85";
export const COLOR_LEUCHTENDGRUEN_OPACITY_90 = "eon-leuchtendgruen-opacity-90";
export const COLOR_LEUCHTENDGRUEN_OPACITY_95 = "eon-leuchtendgruen-opacity-95";
export const COLOR_INDIABLAU_SHADE_1 = "eon-indiablau-shade-1";
export const COLOR_INDIABLAU_SHADE_2 = "eon-indiablau-shade-2";
export const COLOR_INDIABLAU_TINT_1 = "eon-indiablau-tint-1";
export const COLOR_INDIABLAU_TINT_2 = "eon-indiablau-tint-2";
export const COLOR_INDIABLAU_5 = "eon-indiablau-5";
export const COLOR_INDIABLAU_10 = "eon-indiablau-10";
export const COLOR_INDIABLAU_15 = "eon-indiablau-15";
export const COLOR_INDIABLAU_20 = "eon-indiablau-20";
export const COLOR_INDIABLAU_25 = "eon-indiablau-25";
export const COLOR_INDIABLAU_30 = "eon-indiablau-30";
export const COLOR_INDIABLAU_35 = "eon-indiablau-35";
export const COLOR_INDIABLAU_40 = "eon-indiablau-40";
export const COLOR_INDIABLAU_45 = "eon-indiablau-45";
export const COLOR_INDIABLAU_50 = "eon-indiablau-50";
export const COLOR_INDIABLAU_55 = "eon-indiablau-55";
export const COLOR_INDIABLAU_60 = "eon-indiablau-60";
export const COLOR_INDIABLAU_65 = "eon-indiablau-65";
export const COLOR_INDIABLAU_70 = "eon-indiablau-70";
export const COLOR_INDIABLAU_75 = "eon-indiablau-75";
export const COLOR_INDIABLAU_80 = "eon-indiablau-80";
export const COLOR_INDIABLAU_85 = "eon-indiablau-85";
export const COLOR_INDIABLAU_90 = "eon-indiablau-90";
export const COLOR_INDIABLAU_95 = "eon-indiablau-95";
export const COLOR_INDIABLAU_OPACITY_5 = "eon-indiablau-opacity-5";
export const COLOR_INDIABLAU_OPACITY_10 = "eon-indiablau-opacity-10";
export const COLOR_INDIABLAU_OPACITY_15 = "eon-indiablau-opacity-15";
export const COLOR_INDIABLAU_OPACITY_20 = "eon-indiablau-opacity-20";
export const COLOR_INDIABLAU_OPACITY_25 = "eon-indiablau-opacity-25";
export const COLOR_INDIABLAU_OPACITY_30 = "eon-indiablau-opacity-30";
export const COLOR_INDIABLAU_OPACITY_35 = "eon-indiablau-opacity-35";
export const COLOR_INDIABLAU_OPACITY_40 = "eon-indiablau-opacity-40";
export const COLOR_INDIABLAU_OPACITY_45 = "eon-indiablau-opacity-45";
export const COLOR_INDIABLAU_OPACITY_50 = "eon-indiablau-opacity-50";
export const COLOR_INDIABLAU_OPACITY_55 = "eon-indiablau-opacity-55";
export const COLOR_INDIABLAU_OPACITY_60 = "eon-indiablau-opacity-60";
export const COLOR_INDIABLAU_OPACITY_65 = "eon-indiablau-opacity-65";
export const COLOR_INDIABLAU_OPACITY_70 = "eon-indiablau-opacity-70";
export const COLOR_INDIABLAU_OPACITY_75 = "eon-indiablau-opacity-75";
export const COLOR_INDIABLAU_OPACITY_80 = "eon-indiablau-opacity-80";
export const COLOR_INDIABLAU_OPACITY_85 = "eon-indiablau-opacity-85";
export const COLOR_INDIABLAU_OPACITY_90 = "eon-indiablau-opacity-90";
export const COLOR_INDIABLAU_OPACITY_95 = "eon-indiablau-opacity-95";
export const COLOR_ALPENBLAU_SHADE_1 = "eon-alpenblau-shade-1";
export const COLOR_ALPENBLAU_SHADE_2 = "eon-alpenblau-shade-2";
export const COLOR_ALPENBLAU_TINT_1 = "eon-alpenblau-tint-1";
export const COLOR_ALPENBLAU_TINT_2 = "eon-alpenblau-tint-2";
export const COLOR_ALPENBLAU_5 = "eon-alpenblau-5";
export const COLOR_ALPENBLAU_10 = "eon-alpenblau-10";
export const COLOR_ALPENBLAU_15 = "eon-alpenblau-15";
export const COLOR_ALPENBLAU_20 = "eon-alpenblau-20";
export const COLOR_ALPENBLAU_25 = "eon-alpenblau-25";
export const COLOR_ALPENBLAU_30 = "eon-alpenblau-30";
export const COLOR_ALPENBLAU_35 = "eon-alpenblau-35";
export const COLOR_ALPENBLAU_40 = "eon-alpenblau-40";
export const COLOR_ALPENBLAU_45 = "eon-alpenblau-45";
export const COLOR_ALPENBLAU_50 = "eon-alpenblau-50";
export const COLOR_ALPENBLAU_55 = "eon-alpenblau-55";
export const COLOR_ALPENBLAU_60 = "eon-alpenblau-60";
export const COLOR_ALPENBLAU_65 = "eon-alpenblau-65";
export const COLOR_ALPENBLAU_70 = "eon-alpenblau-70";
export const COLOR_ALPENBLAU_75 = "eon-alpenblau-75";
export const COLOR_ALPENBLAU_80 = "eon-alpenblau-80";
export const COLOR_ALPENBLAU_85 = "eon-alpenblau-85";
export const COLOR_ALPENBLAU_90 = "eon-alpenblau-90";
export const COLOR_ALPENBLAU_95 = "eon-alpenblau-95";
export const COLOR_ALPENBLAU_OPACITY_5 = "eon-alpenblau-opacity-5";
export const COLOR_ALPENBLAU_OPACITY_10 = "eon-alpenblau-opacity-10";
export const COLOR_ALPENBLAU_OPACITY_15 = "eon-alpenblau-opacity-15";
export const COLOR_ALPENBLAU_OPACITY_20 = "eon-alpenblau-opacity-20";
export const COLOR_ALPENBLAU_OPACITY_25 = "eon-alpenblau-opacity-25";
export const COLOR_ALPENBLAU_OPACITY_30 = "eon-alpenblau-opacity-30";
export const COLOR_ALPENBLAU_OPACITY_35 = "eon-alpenblau-opacity-35";
export const COLOR_ALPENBLAU_OPACITY_40 = "eon-alpenblau-opacity-40";
export const COLOR_ALPENBLAU_OPACITY_45 = "eon-alpenblau-opacity-45";
export const COLOR_ALPENBLAU_OPACITY_50 = "eon-alpenblau-opacity-50";
export const COLOR_ALPENBLAU_OPACITY_55 = "eon-alpenblau-opacity-55";
export const COLOR_ALPENBLAU_OPACITY_60 = "eon-alpenblau-opacity-60";
export const COLOR_ALPENBLAU_OPACITY_65 = "eon-alpenblau-opacity-65";
export const COLOR_ALPENBLAU_OPACITY_70 = "eon-alpenblau-opacity-70";
export const COLOR_ALPENBLAU_OPACITY_75 = "eon-alpenblau-opacity-75";
export const COLOR_ALPENBLAU_OPACITY_80 = "eon-alpenblau-opacity-80";
export const COLOR_ALPENBLAU_OPACITY_85 = "eon-alpenblau-opacity-85";
export const COLOR_ALPENBLAU_OPACITY_90 = "eon-alpenblau-opacity-90";
export const COLOR_ALPENBLAU_OPACITY_95 = "eon-alpenblau-opacity-95";
export const COLOR_QUARTZGRAU10_SHADE_1 = "eon-quartzgrau10-shade-1";
export const COLOR_QUARTZGRAU10_SHADE_2 = "eon-quartzgrau10-shade-2";
export const COLOR_QUARTZGRAU10_TINT_1 = "eon-quartzgrau10-tint-1";
export const COLOR_QUARTZGRAU10_TINT_2 = "eon-quartzgrau10-tint-2";
export const COLOR_QUARTZGRAU10_5 = "eon-quartzgrau10-5";
export const COLOR_QUARTZGRAU10_10 = "eon-quartzgrau10-10";
export const COLOR_QUARTZGRAU10_15 = "eon-quartzgrau10-15";
export const COLOR_QUARTZGRAU10_20 = "eon-quartzgrau10-20";
export const COLOR_QUARTZGRAU10_25 = "eon-quartzgrau10-25";
export const COLOR_QUARTZGRAU10_30 = "eon-quartzgrau10-30";
export const COLOR_QUARTZGRAU10_35 = "eon-quartzgrau10-35";
export const COLOR_QUARTZGRAU10_40 = "eon-quartzgrau10-40";
export const COLOR_QUARTZGRAU10_45 = "eon-quartzgrau10-45";
export const COLOR_QUARTZGRAU10_50 = "eon-quartzgrau10-50";
export const COLOR_QUARTZGRAU10_55 = "eon-quartzgrau10-55";
export const COLOR_QUARTZGRAU10_60 = "eon-quartzgrau10-60";
export const COLOR_QUARTZGRAU10_65 = "eon-quartzgrau10-65";
export const COLOR_QUARTZGRAU10_70 = "eon-quartzgrau10-70";
export const COLOR_QUARTZGRAU10_75 = "eon-quartzgrau10-75";
export const COLOR_QUARTZGRAU10_80 = "eon-quartzgrau10-80";
export const COLOR_QUARTZGRAU10_85 = "eon-quartzgrau10-85";
export const COLOR_QUARTZGRAU10_90 = "eon-quartzgrau10-90";
export const COLOR_QUARTZGRAU10_95 = "eon-quartzgrau10-95";
export const COLOR_QUARTZGRAU10_OPACITY_5 = "eon-quartzgrau10-opacity-5";
export const COLOR_QUARTZGRAU10_OPACITY_10 = "eon-quartzgrau10-opacity-10";
export const COLOR_QUARTZGRAU10_OPACITY_15 = "eon-quartzgrau10-opacity-15";
export const COLOR_QUARTZGRAU10_OPACITY_20 = "eon-quartzgrau10-opacity-20";
export const COLOR_QUARTZGRAU10_OPACITY_25 = "eon-quartzgrau10-opacity-25";
export const COLOR_QUARTZGRAU10_OPACITY_30 = "eon-quartzgrau10-opacity-30";
export const COLOR_QUARTZGRAU10_OPACITY_35 = "eon-quartzgrau10-opacity-35";
export const COLOR_QUARTZGRAU10_OPACITY_40 = "eon-quartzgrau10-opacity-40";
export const COLOR_QUARTZGRAU10_OPACITY_45 = "eon-quartzgrau10-opacity-45";
export const COLOR_QUARTZGRAU10_OPACITY_50 = "eon-quartzgrau10-opacity-50";
export const COLOR_QUARTZGRAU10_OPACITY_55 = "eon-quartzgrau10-opacity-55";
export const COLOR_QUARTZGRAU10_OPACITY_60 = "eon-quartzgrau10-opacity-60";
export const COLOR_QUARTZGRAU10_OPACITY_65 = "eon-quartzgrau10-opacity-65";
export const COLOR_QUARTZGRAU10_OPACITY_70 = "eon-quartzgrau10-opacity-70";
export const COLOR_QUARTZGRAU10_OPACITY_75 = "eon-quartzgrau10-opacity-75";
export const COLOR_QUARTZGRAU10_OPACITY_80 = "eon-quartzgrau10-opacity-80";
export const COLOR_QUARTZGRAU10_OPACITY_85 = "eon-quartzgrau10-opacity-85";
export const COLOR_QUARTZGRAU10_OPACITY_90 = "eon-quartzgrau10-opacity-90";
export const COLOR_QUARTZGRAU10_OPACITY_95 = "eon-quartzgrau10-opacity-95";
export const COLOR_QUARTZGRAU20_SHADE_1 = "eon-quartzgrau20-shade-1";
export const COLOR_QUARTZGRAU20_SHADE_2 = "eon-quartzgrau20-shade-2";
export const COLOR_QUARTZGRAU20_TINT_1 = "eon-quartzgrau20-tint-1";
export const COLOR_QUARTZGRAU20_TINT_2 = "eon-quartzgrau20-tint-2";
export const COLOR_QUARTZGRAU20_5 = "eon-quartzgrau20-5";
export const COLOR_QUARTZGRAU20_10 = "eon-quartzgrau20-10";
export const COLOR_QUARTZGRAU20_15 = "eon-quartzgrau20-15";
export const COLOR_QUARTZGRAU20_20 = "eon-quartzgrau20-20";
export const COLOR_QUARTZGRAU20_25 = "eon-quartzgrau20-25";
export const COLOR_QUARTZGRAU20_30 = "eon-quartzgrau20-30";
export const COLOR_QUARTZGRAU20_35 = "eon-quartzgrau20-35";
export const COLOR_QUARTZGRAU20_40 = "eon-quartzgrau20-40";
export const COLOR_QUARTZGRAU20_45 = "eon-quartzgrau20-45";
export const COLOR_QUARTZGRAU20_50 = "eon-quartzgrau20-50";
export const COLOR_QUARTZGRAU20_55 = "eon-quartzgrau20-55";
export const COLOR_QUARTZGRAU20_60 = "eon-quartzgrau20-60";
export const COLOR_QUARTZGRAU20_65 = "eon-quartzgrau20-65";
export const COLOR_QUARTZGRAU20_70 = "eon-quartzgrau20-70";
export const COLOR_QUARTZGRAU20_75 = "eon-quartzgrau20-75";
export const COLOR_QUARTZGRAU20_80 = "eon-quartzgrau20-80";
export const COLOR_QUARTZGRAU20_85 = "eon-quartzgrau20-85";
export const COLOR_QUARTZGRAU20_90 = "eon-quartzgrau20-90";
export const COLOR_QUARTZGRAU20_95 = "eon-quartzgrau20-95";
export const COLOR_QUARTZGRAU20_OPACITY_5 = "eon-quartzgrau20-opacity-5";
export const COLOR_QUARTZGRAU20_OPACITY_10 = "eon-quartzgrau20-opacity-10";
export const COLOR_QUARTZGRAU20_OPACITY_15 = "eon-quartzgrau20-opacity-15";
export const COLOR_QUARTZGRAU20_OPACITY_20 = "eon-quartzgrau20-opacity-20";
export const COLOR_QUARTZGRAU20_OPACITY_25 = "eon-quartzgrau20-opacity-25";
export const COLOR_QUARTZGRAU20_OPACITY_30 = "eon-quartzgrau20-opacity-30";
export const COLOR_QUARTZGRAU20_OPACITY_35 = "eon-quartzgrau20-opacity-35";
export const COLOR_QUARTZGRAU20_OPACITY_40 = "eon-quartzgrau20-opacity-40";
export const COLOR_QUARTZGRAU20_OPACITY_45 = "eon-quartzgrau20-opacity-45";
export const COLOR_QUARTZGRAU20_OPACITY_50 = "eon-quartzgrau20-opacity-50";
export const COLOR_QUARTZGRAU20_OPACITY_55 = "eon-quartzgrau20-opacity-55";
export const COLOR_QUARTZGRAU20_OPACITY_60 = "eon-quartzgrau20-opacity-60";
export const COLOR_QUARTZGRAU20_OPACITY_65 = "eon-quartzgrau20-opacity-65";
export const COLOR_QUARTZGRAU20_OPACITY_70 = "eon-quartzgrau20-opacity-70";
export const COLOR_QUARTZGRAU20_OPACITY_75 = "eon-quartzgrau20-opacity-75";
export const COLOR_QUARTZGRAU20_OPACITY_80 = "eon-quartzgrau20-opacity-80";
export const COLOR_QUARTZGRAU20_OPACITY_85 = "eon-quartzgrau20-opacity-85";
export const COLOR_QUARTZGRAU20_OPACITY_90 = "eon-quartzgrau20-opacity-90";
export const COLOR_QUARTZGRAU20_OPACITY_95 = "eon-quartzgrau20-opacity-95";
export const COLOR_QUARTZGRAU50_SHADE_1 = "eon-quartzgrau50-shade-1";
export const COLOR_QUARTZGRAU50_SHADE_2 = "eon-quartzgrau50-shade-2";
export const COLOR_QUARTZGRAU50_TINT_1 = "eon-quartzgrau50-tint-1";
export const COLOR_QUARTZGRAU50_TINT_2 = "eon-quartzgrau50-tint-2";
export const COLOR_QUARTZGRAU50_5 = "eon-quartzgrau50-5";
export const COLOR_QUARTZGRAU50_10 = "eon-quartzgrau50-10";
export const COLOR_QUARTZGRAU50_15 = "eon-quartzgrau50-15";
export const COLOR_QUARTZGRAU50_20 = "eon-quartzgrau50-20";
export const COLOR_QUARTZGRAU50_25 = "eon-quartzgrau50-25";
export const COLOR_QUARTZGRAU50_30 = "eon-quartzgrau50-30";
export const COLOR_QUARTZGRAU50_35 = "eon-quartzgrau50-35";
export const COLOR_QUARTZGRAU50_40 = "eon-quartzgrau50-40";
export const COLOR_QUARTZGRAU50_45 = "eon-quartzgrau50-45";
export const COLOR_QUARTZGRAU50_50 = "eon-quartzgrau50-50";
export const COLOR_QUARTZGRAU50_55 = "eon-quartzgrau50-55";
export const COLOR_QUARTZGRAU50_60 = "eon-quartzgrau50-60";
export const COLOR_QUARTZGRAU50_65 = "eon-quartzgrau50-65";
export const COLOR_QUARTZGRAU50_70 = "eon-quartzgrau50-70";
export const COLOR_QUARTZGRAU50_75 = "eon-quartzgrau50-75";
export const COLOR_QUARTZGRAU50_80 = "eon-quartzgrau50-80";
export const COLOR_QUARTZGRAU50_85 = "eon-quartzgrau50-85";
export const COLOR_QUARTZGRAU50_90 = "eon-quartzgrau50-90";
export const COLOR_QUARTZGRAU50_95 = "eon-quartzgrau50-95";
export const COLOR_QUARTZGRAU50_OPACITY_5 = "eon-quartzgrau50-opacity-5";
export const COLOR_QUARTZGRAU50_OPACITY_10 = "eon-quartzgrau50-opacity-10";
export const COLOR_QUARTZGRAU50_OPACITY_15 = "eon-quartzgrau50-opacity-15";
export const COLOR_QUARTZGRAU50_OPACITY_20 = "eon-quartzgrau50-opacity-20";
export const COLOR_QUARTZGRAU50_OPACITY_25 = "eon-quartzgrau50-opacity-25";
export const COLOR_QUARTZGRAU50_OPACITY_30 = "eon-quartzgrau50-opacity-30";
export const COLOR_QUARTZGRAU50_OPACITY_35 = "eon-quartzgrau50-opacity-35";
export const COLOR_QUARTZGRAU50_OPACITY_40 = "eon-quartzgrau50-opacity-40";
export const COLOR_QUARTZGRAU50_OPACITY_45 = "eon-quartzgrau50-opacity-45";
export const COLOR_QUARTZGRAU50_OPACITY_50 = "eon-quartzgrau50-opacity-50";
export const COLOR_QUARTZGRAU50_OPACITY_55 = "eon-quartzgrau50-opacity-55";
export const COLOR_QUARTZGRAU50_OPACITY_60 = "eon-quartzgrau50-opacity-60";
export const COLOR_QUARTZGRAU50_OPACITY_65 = "eon-quartzgrau50-opacity-65";
export const COLOR_QUARTZGRAU50_OPACITY_70 = "eon-quartzgrau50-opacity-70";
export const COLOR_QUARTZGRAU50_OPACITY_75 = "eon-quartzgrau50-opacity-75";
export const COLOR_QUARTZGRAU50_OPACITY_80 = "eon-quartzgrau50-opacity-80";
export const COLOR_QUARTZGRAU50_OPACITY_85 = "eon-quartzgrau50-opacity-85";
export const COLOR_QUARTZGRAU50_OPACITY_90 = "eon-quartzgrau50-opacity-90";
export const COLOR_QUARTZGRAU50_OPACITY_95 = "eon-quartzgrau50-opacity-95";
export const COLOR_QUARTZGRAU75_SHADE_1 = "eon-quartzgrau75-shade-1";
export const COLOR_QUARTZGRAU75_SHADE_2 = "eon-quartzgrau75-shade-2";
export const COLOR_QUARTZGRAU75_TINT_1 = "eon-quartzgrau75-tint-1";
export const COLOR_QUARTZGRAU75_TINT_2 = "eon-quartzgrau75-tint-2";
export const COLOR_QUARTZGRAU75_5 = "eon-quartzgrau75-5";
export const COLOR_QUARTZGRAU75_10 = "eon-quartzgrau75-10";
export const COLOR_QUARTZGRAU75_15 = "eon-quartzgrau75-15";
export const COLOR_QUARTZGRAU75_20 = "eon-quartzgrau75-20";
export const COLOR_QUARTZGRAU75_25 = "eon-quartzgrau75-25";
export const COLOR_QUARTZGRAU75_30 = "eon-quartzgrau75-30";
export const COLOR_QUARTZGRAU75_35 = "eon-quartzgrau75-35";
export const COLOR_QUARTZGRAU75_40 = "eon-quartzgrau75-40";
export const COLOR_QUARTZGRAU75_45 = "eon-quartzgrau75-45";
export const COLOR_QUARTZGRAU75_50 = "eon-quartzgrau75-50";
export const COLOR_QUARTZGRAU75_55 = "eon-quartzgrau75-55";
export const COLOR_QUARTZGRAU75_60 = "eon-quartzgrau75-60";
export const COLOR_QUARTZGRAU75_65 = "eon-quartzgrau75-65";
export const COLOR_QUARTZGRAU75_70 = "eon-quartzgrau75-70";
export const COLOR_QUARTZGRAU75_75 = "eon-quartzgrau75-75";
export const COLOR_QUARTZGRAU75_80 = "eon-quartzgrau75-80";
export const COLOR_QUARTZGRAU75_85 = "eon-quartzgrau75-85";
export const COLOR_QUARTZGRAU75_90 = "eon-quartzgrau75-90";
export const COLOR_QUARTZGRAU75_95 = "eon-quartzgrau75-95";
export const COLOR_QUARTZGRAU75_OPACITY_5 = "eon-quartzgrau75-opacity-5";
export const COLOR_QUARTZGRAU75_OPACITY_10 = "eon-quartzgrau75-opacity-10";
export const COLOR_QUARTZGRAU75_OPACITY_15 = "eon-quartzgrau75-opacity-15";
export const COLOR_QUARTZGRAU75_OPACITY_20 = "eon-quartzgrau75-opacity-20";
export const COLOR_QUARTZGRAU75_OPACITY_25 = "eon-quartzgrau75-opacity-25";
export const COLOR_QUARTZGRAU75_OPACITY_30 = "eon-quartzgrau75-opacity-30";
export const COLOR_QUARTZGRAU75_OPACITY_35 = "eon-quartzgrau75-opacity-35";
export const COLOR_QUARTZGRAU75_OPACITY_40 = "eon-quartzgrau75-opacity-40";
export const COLOR_QUARTZGRAU75_OPACITY_45 = "eon-quartzgrau75-opacity-45";
export const COLOR_QUARTZGRAU75_OPACITY_50 = "eon-quartzgrau75-opacity-50";
export const COLOR_QUARTZGRAU75_OPACITY_55 = "eon-quartzgrau75-opacity-55";
export const COLOR_QUARTZGRAU75_OPACITY_60 = "eon-quartzgrau75-opacity-60";
export const COLOR_QUARTZGRAU75_OPACITY_65 = "eon-quartzgrau75-opacity-65";
export const COLOR_QUARTZGRAU75_OPACITY_70 = "eon-quartzgrau75-opacity-70";
export const COLOR_QUARTZGRAU75_OPACITY_75 = "eon-quartzgrau75-opacity-75";
export const COLOR_QUARTZGRAU75_OPACITY_80 = "eon-quartzgrau75-opacity-80";
export const COLOR_QUARTZGRAU75_OPACITY_85 = "eon-quartzgrau75-opacity-85";
export const COLOR_QUARTZGRAU75_OPACITY_90 = "eon-quartzgrau75-opacity-90";
export const COLOR_QUARTZGRAU75_OPACITY_95 = "eon-quartzgrau75-opacity-95";

export const EON_COLORS = [
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_SCHWARZ,
  COLOR_ORIENTGELB,
  COLOR_FASERGRUEN,
  COLOR_ARKTISGRUEN,
  COLOR_KARIBIKBLAU,
  COLOR_BISCHOFSROT,
  COLOR_ALTROSA,
  COLOR_KERZENGELB,
  COLOR_BRILLANTKARMIN,
  COLOR_ERDBEERROT,
  COLOR_VERKEHRSORANGE,
  COLOR_DAHLIENGELB,
  COLOR_LEUCHTENDGRUEN,
  COLOR_INDIABLAU,
  COLOR_ALPENBLAU,
  COLOR_QUARTZGRAU10,
  COLOR_QUARTZGRAU20,
  COLOR_QUARTZGRAU50,
  COLOR_QUARTZGRAU75,
  COLOR_BRIGHT_SHADE_1,
  COLOR_BRIGHT_SHADE_2,
  COLOR_BRIGHT_TINT_1,
  COLOR_BRIGHT_TINT_2,
  COLOR_BRIGHT_5,
  COLOR_BRIGHT_10,
  COLOR_BRIGHT_15,
  COLOR_BRIGHT_20,
  COLOR_BRIGHT_25,
  COLOR_BRIGHT_30,
  COLOR_BRIGHT_35,
  COLOR_BRIGHT_40,
  COLOR_BRIGHT_45,
  COLOR_BRIGHT_50,
  COLOR_BRIGHT_55,
  COLOR_BRIGHT_60,
  COLOR_BRIGHT_65,
  COLOR_BRIGHT_70,
  COLOR_BRIGHT_75,
  COLOR_BRIGHT_80,
  COLOR_BRIGHT_85,
  COLOR_BRIGHT_90,
  COLOR_BRIGHT_95,
  COLOR_BRIGHT_OPACITY_5,
  COLOR_BRIGHT_OPACITY_10,
  COLOR_BRIGHT_OPACITY_15,
  COLOR_BRIGHT_OPACITY_20,
  COLOR_BRIGHT_OPACITY_25,
  COLOR_BRIGHT_OPACITY_30,
  COLOR_BRIGHT_OPACITY_35,
  COLOR_BRIGHT_OPACITY_40,
  COLOR_BRIGHT_OPACITY_45,
  COLOR_BRIGHT_OPACITY_50,
  COLOR_BRIGHT_OPACITY_55,
  COLOR_BRIGHT_OPACITY_60,
  COLOR_BRIGHT_OPACITY_65,
  COLOR_BRIGHT_OPACITY_70,
  COLOR_BRIGHT_OPACITY_75,
  COLOR_BRIGHT_OPACITY_80,
  COLOR_BRIGHT_OPACITY_85,
  COLOR_BRIGHT_OPACITY_90,
  COLOR_BRIGHT_OPACITY_95,
  COLOR_DARK_SHADE_1,
  COLOR_DARK_SHADE_2,
  COLOR_DARK_TINT_1,
  COLOR_DARK_TINT_2,
  COLOR_DARK_5,
  COLOR_DARK_10,
  COLOR_DARK_15,
  COLOR_DARK_20,
  COLOR_DARK_25,
  COLOR_DARK_30,
  COLOR_DARK_35,
  COLOR_DARK_40,
  COLOR_DARK_45,
  COLOR_DARK_50,
  COLOR_DARK_55,
  COLOR_DARK_60,
  COLOR_DARK_65,
  COLOR_DARK_70,
  COLOR_DARK_75,
  COLOR_DARK_80,
  COLOR_DARK_85,
  COLOR_DARK_90,
  COLOR_DARK_95,
  COLOR_DARK_OPACITY_5,
  COLOR_DARK_OPACITY_10,
  COLOR_DARK_OPACITY_15,
  COLOR_DARK_OPACITY_20,
  COLOR_DARK_OPACITY_25,
  COLOR_DARK_OPACITY_30,
  COLOR_DARK_OPACITY_35,
  COLOR_DARK_OPACITY_40,
  COLOR_DARK_OPACITY_45,
  COLOR_DARK_OPACITY_50,
  COLOR_DARK_OPACITY_55,
  COLOR_DARK_OPACITY_60,
  COLOR_DARK_OPACITY_65,
  COLOR_DARK_OPACITY_70,
  COLOR_DARK_OPACITY_75,
  COLOR_DARK_OPACITY_80,
  COLOR_DARK_OPACITY_85,
  COLOR_DARK_OPACITY_90,
  COLOR_DARK_OPACITY_95,
  COLOR_SCHWARZ_SHADE_1,
  COLOR_SCHWARZ_SHADE_2,
  COLOR_SCHWARZ_TINT_1,
  COLOR_SCHWARZ_TINT_2,
  COLOR_SCHWARZ_5,
  COLOR_SCHWARZ_10,
  COLOR_SCHWARZ_15,
  COLOR_SCHWARZ_20,
  COLOR_SCHWARZ_25,
  COLOR_SCHWARZ_30,
  COLOR_SCHWARZ_35,
  COLOR_SCHWARZ_40,
  COLOR_SCHWARZ_45,
  COLOR_SCHWARZ_50,
  COLOR_SCHWARZ_55,
  COLOR_SCHWARZ_60,
  COLOR_SCHWARZ_65,
  COLOR_SCHWARZ_70,
  COLOR_SCHWARZ_75,
  COLOR_SCHWARZ_80,
  COLOR_SCHWARZ_85,
  COLOR_SCHWARZ_90,
  COLOR_SCHWARZ_95,
  COLOR_SCHWARZ_OPACITY_5,
  COLOR_SCHWARZ_OPACITY_10,
  COLOR_SCHWARZ_OPACITY_15,
  COLOR_SCHWARZ_OPACITY_20,
  COLOR_SCHWARZ_OPACITY_25,
  COLOR_SCHWARZ_OPACITY_30,
  COLOR_SCHWARZ_OPACITY_35,
  COLOR_SCHWARZ_OPACITY_40,
  COLOR_SCHWARZ_OPACITY_45,
  COLOR_SCHWARZ_OPACITY_50,
  COLOR_SCHWARZ_OPACITY_55,
  COLOR_SCHWARZ_OPACITY_60,
  COLOR_SCHWARZ_OPACITY_65,
  COLOR_SCHWARZ_OPACITY_70,
  COLOR_SCHWARZ_OPACITY_75,
  COLOR_SCHWARZ_OPACITY_80,
  COLOR_SCHWARZ_OPACITY_85,
  COLOR_SCHWARZ_OPACITY_90,
  COLOR_SCHWARZ_OPACITY_95,
  COLOR_ORIENTGELB_SHADE_1,
  COLOR_ORIENTGELB_SHADE_2,
  COLOR_ORIENTGELB_TINT_1,
  COLOR_ORIENTGELB_TINT_2,
  COLOR_ORIENTGELB_5,
  COLOR_ORIENTGELB_10,
  COLOR_ORIENTGELB_15,
  COLOR_ORIENTGELB_20,
  COLOR_ORIENTGELB_25,
  COLOR_ORIENTGELB_30,
  COLOR_ORIENTGELB_35,
  COLOR_ORIENTGELB_40,
  COLOR_ORIENTGELB_45,
  COLOR_ORIENTGELB_50,
  COLOR_ORIENTGELB_55,
  COLOR_ORIENTGELB_60,
  COLOR_ORIENTGELB_65,
  COLOR_ORIENTGELB_70,
  COLOR_ORIENTGELB_75,
  COLOR_ORIENTGELB_80,
  COLOR_ORIENTGELB_85,
  COLOR_ORIENTGELB_90,
  COLOR_ORIENTGELB_95,
  COLOR_ORIENTGELB_OPACITY_5,
  COLOR_ORIENTGELB_OPACITY_10,
  COLOR_ORIENTGELB_OPACITY_15,
  COLOR_ORIENTGELB_OPACITY_20,
  COLOR_ORIENTGELB_OPACITY_25,
  COLOR_ORIENTGELB_OPACITY_30,
  COLOR_ORIENTGELB_OPACITY_35,
  COLOR_ORIENTGELB_OPACITY_40,
  COLOR_ORIENTGELB_OPACITY_45,
  COLOR_ORIENTGELB_OPACITY_50,
  COLOR_ORIENTGELB_OPACITY_55,
  COLOR_ORIENTGELB_OPACITY_60,
  COLOR_ORIENTGELB_OPACITY_65,
  COLOR_ORIENTGELB_OPACITY_70,
  COLOR_ORIENTGELB_OPACITY_75,
  COLOR_ORIENTGELB_OPACITY_80,
  COLOR_ORIENTGELB_OPACITY_85,
  COLOR_ORIENTGELB_OPACITY_90,
  COLOR_ORIENTGELB_OPACITY_95,
  COLOR_FASERGRUEN_SHADE_1,
  COLOR_FASERGRUEN_SHADE_2,
  COLOR_FASERGRUEN_TINT_1,
  COLOR_FASERGRUEN_TINT_2,
  COLOR_FASERGRUEN_5,
  COLOR_FASERGRUEN_10,
  COLOR_FASERGRUEN_15,
  COLOR_FASERGRUEN_20,
  COLOR_FASERGRUEN_25,
  COLOR_FASERGRUEN_30,
  COLOR_FASERGRUEN_35,
  COLOR_FASERGRUEN_40,
  COLOR_FASERGRUEN_45,
  COLOR_FASERGRUEN_50,
  COLOR_FASERGRUEN_55,
  COLOR_FASERGRUEN_60,
  COLOR_FASERGRUEN_65,
  COLOR_FASERGRUEN_70,
  COLOR_FASERGRUEN_75,
  COLOR_FASERGRUEN_80,
  COLOR_FASERGRUEN_85,
  COLOR_FASERGRUEN_90,
  COLOR_FASERGRUEN_95,
  COLOR_FASERGRUEN_OPACITY_5,
  COLOR_FASERGRUEN_OPACITY_10,
  COLOR_FASERGRUEN_OPACITY_15,
  COLOR_FASERGRUEN_OPACITY_20,
  COLOR_FASERGRUEN_OPACITY_25,
  COLOR_FASERGRUEN_OPACITY_30,
  COLOR_FASERGRUEN_OPACITY_35,
  COLOR_FASERGRUEN_OPACITY_40,
  COLOR_FASERGRUEN_OPACITY_45,
  COLOR_FASERGRUEN_OPACITY_50,
  COLOR_FASERGRUEN_OPACITY_55,
  COLOR_FASERGRUEN_OPACITY_60,
  COLOR_FASERGRUEN_OPACITY_65,
  COLOR_FASERGRUEN_OPACITY_70,
  COLOR_FASERGRUEN_OPACITY_75,
  COLOR_FASERGRUEN_OPACITY_80,
  COLOR_FASERGRUEN_OPACITY_85,
  COLOR_FASERGRUEN_OPACITY_90,
  COLOR_FASERGRUEN_OPACITY_95,
  COLOR_ARKTISGRUEN_SHADE_1,
  COLOR_ARKTISGRUEN_SHADE_2,
  COLOR_ARKTISGRUEN_TINT_1,
  COLOR_ARKTISGRUEN_TINT_2,
  COLOR_ARKTISGRUEN_5,
  COLOR_ARKTISGRUEN_10,
  COLOR_ARKTISGRUEN_15,
  COLOR_ARKTISGRUEN_20,
  COLOR_ARKTISGRUEN_25,
  COLOR_ARKTISGRUEN_30,
  COLOR_ARKTISGRUEN_35,
  COLOR_ARKTISGRUEN_40,
  COLOR_ARKTISGRUEN_45,
  COLOR_ARKTISGRUEN_50,
  COLOR_ARKTISGRUEN_55,
  COLOR_ARKTISGRUEN_60,
  COLOR_ARKTISGRUEN_65,
  COLOR_ARKTISGRUEN_70,
  COLOR_ARKTISGRUEN_75,
  COLOR_ARKTISGRUEN_80,
  COLOR_ARKTISGRUEN_85,
  COLOR_ARKTISGRUEN_90,
  COLOR_ARKTISGRUEN_95,
  COLOR_ARKTISGRUEN_OPACITY_5,
  COLOR_ARKTISGRUEN_OPACITY_10,
  COLOR_ARKTISGRUEN_OPACITY_15,
  COLOR_ARKTISGRUEN_OPACITY_20,
  COLOR_ARKTISGRUEN_OPACITY_25,
  COLOR_ARKTISGRUEN_OPACITY_30,
  COLOR_ARKTISGRUEN_OPACITY_35,
  COLOR_ARKTISGRUEN_OPACITY_40,
  COLOR_ARKTISGRUEN_OPACITY_45,
  COLOR_ARKTISGRUEN_OPACITY_50,
  COLOR_ARKTISGRUEN_OPACITY_55,
  COLOR_ARKTISGRUEN_OPACITY_60,
  COLOR_ARKTISGRUEN_OPACITY_65,
  COLOR_ARKTISGRUEN_OPACITY_70,
  COLOR_ARKTISGRUEN_OPACITY_75,
  COLOR_ARKTISGRUEN_OPACITY_80,
  COLOR_ARKTISGRUEN_OPACITY_85,
  COLOR_ARKTISGRUEN_OPACITY_90,
  COLOR_ARKTISGRUEN_OPACITY_95,
  COLOR_KARIBIKBLAU_SHADE_1,
  COLOR_KARIBIKBLAU_SHADE_2,
  COLOR_KARIBIKBLAU_TINT_1,
  COLOR_KARIBIKBLAU_TINT_2,
  COLOR_KARIBIKBLAU_5,
  COLOR_KARIBIKBLAU_10,
  COLOR_KARIBIKBLAU_15,
  COLOR_KARIBIKBLAU_20,
  COLOR_KARIBIKBLAU_25,
  COLOR_KARIBIKBLAU_30,
  COLOR_KARIBIKBLAU_35,
  COLOR_KARIBIKBLAU_40,
  COLOR_KARIBIKBLAU_45,
  COLOR_KARIBIKBLAU_50,
  COLOR_KARIBIKBLAU_55,
  COLOR_KARIBIKBLAU_60,
  COLOR_KARIBIKBLAU_65,
  COLOR_KARIBIKBLAU_70,
  COLOR_KARIBIKBLAU_75,
  COLOR_KARIBIKBLAU_80,
  COLOR_KARIBIKBLAU_85,
  COLOR_KARIBIKBLAU_90,
  COLOR_KARIBIKBLAU_95,
  COLOR_KARIBIKBLAU_OPACITY_5,
  COLOR_KARIBIKBLAU_OPACITY_10,
  COLOR_KARIBIKBLAU_OPACITY_15,
  COLOR_KARIBIKBLAU_OPACITY_20,
  COLOR_KARIBIKBLAU_OPACITY_25,
  COLOR_KARIBIKBLAU_OPACITY_30,
  COLOR_KARIBIKBLAU_OPACITY_35,
  COLOR_KARIBIKBLAU_OPACITY_40,
  COLOR_KARIBIKBLAU_OPACITY_45,
  COLOR_KARIBIKBLAU_OPACITY_50,
  COLOR_KARIBIKBLAU_OPACITY_55,
  COLOR_KARIBIKBLAU_OPACITY_60,
  COLOR_KARIBIKBLAU_OPACITY_65,
  COLOR_KARIBIKBLAU_OPACITY_70,
  COLOR_KARIBIKBLAU_OPACITY_75,
  COLOR_KARIBIKBLAU_OPACITY_80,
  COLOR_KARIBIKBLAU_OPACITY_85,
  COLOR_KARIBIKBLAU_OPACITY_90,
  COLOR_KARIBIKBLAU_OPACITY_95,
  COLOR_BISCHOFSROT_SHADE_1,
  COLOR_BISCHOFSROT_SHADE_2,
  COLOR_BISCHOFSROT_TINT_1,
  COLOR_BISCHOFSROT_TINT_2,
  COLOR_BISCHOFSROT_5,
  COLOR_BISCHOFSROT_10,
  COLOR_BISCHOFSROT_15,
  COLOR_BISCHOFSROT_20,
  COLOR_BISCHOFSROT_25,
  COLOR_BISCHOFSROT_30,
  COLOR_BISCHOFSROT_35,
  COLOR_BISCHOFSROT_40,
  COLOR_BISCHOFSROT_45,
  COLOR_BISCHOFSROT_50,
  COLOR_BISCHOFSROT_55,
  COLOR_BISCHOFSROT_60,
  COLOR_BISCHOFSROT_65,
  COLOR_BISCHOFSROT_70,
  COLOR_BISCHOFSROT_75,
  COLOR_BISCHOFSROT_80,
  COLOR_BISCHOFSROT_85,
  COLOR_BISCHOFSROT_90,
  COLOR_BISCHOFSROT_95,
  COLOR_BISCHOFSROT_OPACITY_5,
  COLOR_BISCHOFSROT_OPACITY_10,
  COLOR_BISCHOFSROT_OPACITY_15,
  COLOR_BISCHOFSROT_OPACITY_20,
  COLOR_BISCHOFSROT_OPACITY_25,
  COLOR_BISCHOFSROT_OPACITY_30,
  COLOR_BISCHOFSROT_OPACITY_35,
  COLOR_BISCHOFSROT_OPACITY_40,
  COLOR_BISCHOFSROT_OPACITY_45,
  COLOR_BISCHOFSROT_OPACITY_50,
  COLOR_BISCHOFSROT_OPACITY_55,
  COLOR_BISCHOFSROT_OPACITY_60,
  COLOR_BISCHOFSROT_OPACITY_65,
  COLOR_BISCHOFSROT_OPACITY_70,
  COLOR_BISCHOFSROT_OPACITY_75,
  COLOR_BISCHOFSROT_OPACITY_80,
  COLOR_BISCHOFSROT_OPACITY_85,
  COLOR_BISCHOFSROT_OPACITY_90,
  COLOR_BISCHOFSROT_OPACITY_95,
  COLOR_ALTROSA_SHADE_1,
  COLOR_ALTROSA_SHADE_2,
  COLOR_ALTROSA_TINT_1,
  COLOR_ALTROSA_TINT_2,
  COLOR_ALTROSA_5,
  COLOR_ALTROSA_10,
  COLOR_ALTROSA_15,
  COLOR_ALTROSA_20,
  COLOR_ALTROSA_25,
  COLOR_ALTROSA_30,
  COLOR_ALTROSA_35,
  COLOR_ALTROSA_40,
  COLOR_ALTROSA_45,
  COLOR_ALTROSA_50,
  COLOR_ALTROSA_55,
  COLOR_ALTROSA_60,
  COLOR_ALTROSA_65,
  COLOR_ALTROSA_70,
  COLOR_ALTROSA_75,
  COLOR_ALTROSA_80,
  COLOR_ALTROSA_85,
  COLOR_ALTROSA_90,
  COLOR_ALTROSA_95,
  COLOR_ALTROSA_OPACITY_5,
  COLOR_ALTROSA_OPACITY_10,
  COLOR_ALTROSA_OPACITY_15,
  COLOR_ALTROSA_OPACITY_20,
  COLOR_ALTROSA_OPACITY_25,
  COLOR_ALTROSA_OPACITY_30,
  COLOR_ALTROSA_OPACITY_35,
  COLOR_ALTROSA_OPACITY_40,
  COLOR_ALTROSA_OPACITY_45,
  COLOR_ALTROSA_OPACITY_50,
  COLOR_ALTROSA_OPACITY_55,
  COLOR_ALTROSA_OPACITY_60,
  COLOR_ALTROSA_OPACITY_65,
  COLOR_ALTROSA_OPACITY_70,
  COLOR_ALTROSA_OPACITY_75,
  COLOR_ALTROSA_OPACITY_80,
  COLOR_ALTROSA_OPACITY_85,
  COLOR_ALTROSA_OPACITY_90,
  COLOR_ALTROSA_OPACITY_95,
  COLOR_KERZENGELB_SHADE_1,
  COLOR_KERZENGELB_SHADE_2,
  COLOR_KERZENGELB_TINT_1,
  COLOR_KERZENGELB_TINT_2,
  COLOR_KERZENGELB_5,
  COLOR_KERZENGELB_10,
  COLOR_KERZENGELB_15,
  COLOR_KERZENGELB_20,
  COLOR_KERZENGELB_25,
  COLOR_KERZENGELB_30,
  COLOR_KERZENGELB_35,
  COLOR_KERZENGELB_40,
  COLOR_KERZENGELB_45,
  COLOR_KERZENGELB_50,
  COLOR_KERZENGELB_55,
  COLOR_KERZENGELB_60,
  COLOR_KERZENGELB_65,
  COLOR_KERZENGELB_70,
  COLOR_KERZENGELB_75,
  COLOR_KERZENGELB_80,
  COLOR_KERZENGELB_85,
  COLOR_KERZENGELB_90,
  COLOR_KERZENGELB_95,
  COLOR_KERZENGELB_OPACITY_5,
  COLOR_KERZENGELB_OPACITY_10,
  COLOR_KERZENGELB_OPACITY_15,
  COLOR_KERZENGELB_OPACITY_20,
  COLOR_KERZENGELB_OPACITY_25,
  COLOR_KERZENGELB_OPACITY_30,
  COLOR_KERZENGELB_OPACITY_35,
  COLOR_KERZENGELB_OPACITY_40,
  COLOR_KERZENGELB_OPACITY_45,
  COLOR_KERZENGELB_OPACITY_50,
  COLOR_KERZENGELB_OPACITY_55,
  COLOR_KERZENGELB_OPACITY_60,
  COLOR_KERZENGELB_OPACITY_65,
  COLOR_KERZENGELB_OPACITY_70,
  COLOR_KERZENGELB_OPACITY_75,
  COLOR_KERZENGELB_OPACITY_80,
  COLOR_KERZENGELB_OPACITY_85,
  COLOR_KERZENGELB_OPACITY_90,
  COLOR_KERZENGELB_OPACITY_95,
  COLOR_BRILLANTKARMIN_SHADE_1,
  COLOR_BRILLANTKARMIN_SHADE_2,
  COLOR_BRILLANTKARMIN_TINT_1,
  COLOR_BRILLANTKARMIN_TINT_2,
  COLOR_BRILLANTKARMIN_5,
  COLOR_BRILLANTKARMIN_10,
  COLOR_BRILLANTKARMIN_15,
  COLOR_BRILLANTKARMIN_20,
  COLOR_BRILLANTKARMIN_25,
  COLOR_BRILLANTKARMIN_30,
  COLOR_BRILLANTKARMIN_35,
  COLOR_BRILLANTKARMIN_40,
  COLOR_BRILLANTKARMIN_45,
  COLOR_BRILLANTKARMIN_50,
  COLOR_BRILLANTKARMIN_55,
  COLOR_BRILLANTKARMIN_60,
  COLOR_BRILLANTKARMIN_65,
  COLOR_BRILLANTKARMIN_70,
  COLOR_BRILLANTKARMIN_75,
  COLOR_BRILLANTKARMIN_80,
  COLOR_BRILLANTKARMIN_85,
  COLOR_BRILLANTKARMIN_90,
  COLOR_BRILLANTKARMIN_95,
  COLOR_BRILLANTKARMIN_OPACITY_5,
  COLOR_BRILLANTKARMIN_OPACITY_10,
  COLOR_BRILLANTKARMIN_OPACITY_15,
  COLOR_BRILLANTKARMIN_OPACITY_20,
  COLOR_BRILLANTKARMIN_OPACITY_25,
  COLOR_BRILLANTKARMIN_OPACITY_30,
  COLOR_BRILLANTKARMIN_OPACITY_35,
  COLOR_BRILLANTKARMIN_OPACITY_40,
  COLOR_BRILLANTKARMIN_OPACITY_45,
  COLOR_BRILLANTKARMIN_OPACITY_50,
  COLOR_BRILLANTKARMIN_OPACITY_55,
  COLOR_BRILLANTKARMIN_OPACITY_60,
  COLOR_BRILLANTKARMIN_OPACITY_65,
  COLOR_BRILLANTKARMIN_OPACITY_70,
  COLOR_BRILLANTKARMIN_OPACITY_75,
  COLOR_BRILLANTKARMIN_OPACITY_80,
  COLOR_BRILLANTKARMIN_OPACITY_85,
  COLOR_BRILLANTKARMIN_OPACITY_90,
  COLOR_BRILLANTKARMIN_OPACITY_95,
  COLOR_ERDBEERROT_SHADE_1,
  COLOR_ERDBEERROT_SHADE_2,
  COLOR_ERDBEERROT_TINT_1,
  COLOR_ERDBEERROT_TINT_2,
  COLOR_ERDBEERROT_5,
  COLOR_ERDBEERROT_10,
  COLOR_ERDBEERROT_15,
  COLOR_ERDBEERROT_20,
  COLOR_ERDBEERROT_25,
  COLOR_ERDBEERROT_30,
  COLOR_ERDBEERROT_35,
  COLOR_ERDBEERROT_40,
  COLOR_ERDBEERROT_45,
  COLOR_ERDBEERROT_50,
  COLOR_ERDBEERROT_55,
  COLOR_ERDBEERROT_60,
  COLOR_ERDBEERROT_65,
  COLOR_ERDBEERROT_70,
  COLOR_ERDBEERROT_75,
  COLOR_ERDBEERROT_80,
  COLOR_ERDBEERROT_85,
  COLOR_ERDBEERROT_90,
  COLOR_ERDBEERROT_95,
  COLOR_ERDBEERROT_OPACITY_5,
  COLOR_ERDBEERROT_OPACITY_10,
  COLOR_ERDBEERROT_OPACITY_15,
  COLOR_ERDBEERROT_OPACITY_20,
  COLOR_ERDBEERROT_OPACITY_25,
  COLOR_ERDBEERROT_OPACITY_30,
  COLOR_ERDBEERROT_OPACITY_35,
  COLOR_ERDBEERROT_OPACITY_40,
  COLOR_ERDBEERROT_OPACITY_45,
  COLOR_ERDBEERROT_OPACITY_50,
  COLOR_ERDBEERROT_OPACITY_55,
  COLOR_ERDBEERROT_OPACITY_60,
  COLOR_ERDBEERROT_OPACITY_65,
  COLOR_ERDBEERROT_OPACITY_70,
  COLOR_ERDBEERROT_OPACITY_75,
  COLOR_ERDBEERROT_OPACITY_80,
  COLOR_ERDBEERROT_OPACITY_85,
  COLOR_ERDBEERROT_OPACITY_90,
  COLOR_ERDBEERROT_OPACITY_95,
  COLOR_VERKEHRSORANGE_SHADE_1,
  COLOR_VERKEHRSORANGE_SHADE_2,
  COLOR_VERKEHRSORANGE_TINT_1,
  COLOR_VERKEHRSORANGE_TINT_2,
  COLOR_VERKEHRSORANGE_5,
  COLOR_VERKEHRSORANGE_10,
  COLOR_VERKEHRSORANGE_15,
  COLOR_VERKEHRSORANGE_20,
  COLOR_VERKEHRSORANGE_25,
  COLOR_VERKEHRSORANGE_30,
  COLOR_VERKEHRSORANGE_35,
  COLOR_VERKEHRSORANGE_40,
  COLOR_VERKEHRSORANGE_45,
  COLOR_VERKEHRSORANGE_50,
  COLOR_VERKEHRSORANGE_55,
  COLOR_VERKEHRSORANGE_60,
  COLOR_VERKEHRSORANGE_65,
  COLOR_VERKEHRSORANGE_70,
  COLOR_VERKEHRSORANGE_75,
  COLOR_VERKEHRSORANGE_80,
  COLOR_VERKEHRSORANGE_85,
  COLOR_VERKEHRSORANGE_90,
  COLOR_VERKEHRSORANGE_95,
  COLOR_VERKEHRSORANGE_OPACITY_5,
  COLOR_VERKEHRSORANGE_OPACITY_10,
  COLOR_VERKEHRSORANGE_OPACITY_15,
  COLOR_VERKEHRSORANGE_OPACITY_20,
  COLOR_VERKEHRSORANGE_OPACITY_25,
  COLOR_VERKEHRSORANGE_OPACITY_30,
  COLOR_VERKEHRSORANGE_OPACITY_35,
  COLOR_VERKEHRSORANGE_OPACITY_40,
  COLOR_VERKEHRSORANGE_OPACITY_45,
  COLOR_VERKEHRSORANGE_OPACITY_50,
  COLOR_VERKEHRSORANGE_OPACITY_55,
  COLOR_VERKEHRSORANGE_OPACITY_60,
  COLOR_VERKEHRSORANGE_OPACITY_65,
  COLOR_VERKEHRSORANGE_OPACITY_70,
  COLOR_VERKEHRSORANGE_OPACITY_75,
  COLOR_VERKEHRSORANGE_OPACITY_80,
  COLOR_VERKEHRSORANGE_OPACITY_85,
  COLOR_VERKEHRSORANGE_OPACITY_90,
  COLOR_VERKEHRSORANGE_OPACITY_95,
  COLOR_DAHLIENGELB_SHADE_1,
  COLOR_DAHLIENGELB_SHADE_2,
  COLOR_DAHLIENGELB_TINT_1,
  COLOR_DAHLIENGELB_TINT_2,
  COLOR_DAHLIENGELB_5,
  COLOR_DAHLIENGELB_10,
  COLOR_DAHLIENGELB_15,
  COLOR_DAHLIENGELB_20,
  COLOR_DAHLIENGELB_25,
  COLOR_DAHLIENGELB_30,
  COLOR_DAHLIENGELB_35,
  COLOR_DAHLIENGELB_40,
  COLOR_DAHLIENGELB_45,
  COLOR_DAHLIENGELB_50,
  COLOR_DAHLIENGELB_55,
  COLOR_DAHLIENGELB_60,
  COLOR_DAHLIENGELB_65,
  COLOR_DAHLIENGELB_70,
  COLOR_DAHLIENGELB_75,
  COLOR_DAHLIENGELB_80,
  COLOR_DAHLIENGELB_85,
  COLOR_DAHLIENGELB_90,
  COLOR_DAHLIENGELB_95,
  COLOR_DAHLIENGELB_OPACITY_5,
  COLOR_DAHLIENGELB_OPACITY_10,
  COLOR_DAHLIENGELB_OPACITY_15,
  COLOR_DAHLIENGELB_OPACITY_20,
  COLOR_DAHLIENGELB_OPACITY_25,
  COLOR_DAHLIENGELB_OPACITY_30,
  COLOR_DAHLIENGELB_OPACITY_35,
  COLOR_DAHLIENGELB_OPACITY_40,
  COLOR_DAHLIENGELB_OPACITY_45,
  COLOR_DAHLIENGELB_OPACITY_50,
  COLOR_DAHLIENGELB_OPACITY_55,
  COLOR_DAHLIENGELB_OPACITY_60,
  COLOR_DAHLIENGELB_OPACITY_65,
  COLOR_DAHLIENGELB_OPACITY_70,
  COLOR_DAHLIENGELB_OPACITY_75,
  COLOR_DAHLIENGELB_OPACITY_80,
  COLOR_DAHLIENGELB_OPACITY_85,
  COLOR_DAHLIENGELB_OPACITY_90,
  COLOR_DAHLIENGELB_OPACITY_95,
  COLOR_LEUCHTENDGRUEN_SHADE_1,
  COLOR_LEUCHTENDGRUEN_SHADE_2,
  COLOR_LEUCHTENDGRUEN_TINT_1,
  COLOR_LEUCHTENDGRUEN_TINT_2,
  COLOR_LEUCHTENDGRUEN_5,
  COLOR_LEUCHTENDGRUEN_10,
  COLOR_LEUCHTENDGRUEN_15,
  COLOR_LEUCHTENDGRUEN_20,
  COLOR_LEUCHTENDGRUEN_25,
  COLOR_LEUCHTENDGRUEN_30,
  COLOR_LEUCHTENDGRUEN_35,
  COLOR_LEUCHTENDGRUEN_40,
  COLOR_LEUCHTENDGRUEN_45,
  COLOR_LEUCHTENDGRUEN_50,
  COLOR_LEUCHTENDGRUEN_55,
  COLOR_LEUCHTENDGRUEN_60,
  COLOR_LEUCHTENDGRUEN_65,
  COLOR_LEUCHTENDGRUEN_70,
  COLOR_LEUCHTENDGRUEN_75,
  COLOR_LEUCHTENDGRUEN_80,
  COLOR_LEUCHTENDGRUEN_85,
  COLOR_LEUCHTENDGRUEN_90,
  COLOR_LEUCHTENDGRUEN_95,
  COLOR_LEUCHTENDGRUEN_OPACITY_5,
  COLOR_LEUCHTENDGRUEN_OPACITY_10,
  COLOR_LEUCHTENDGRUEN_OPACITY_15,
  COLOR_LEUCHTENDGRUEN_OPACITY_20,
  COLOR_LEUCHTENDGRUEN_OPACITY_25,
  COLOR_LEUCHTENDGRUEN_OPACITY_30,
  COLOR_LEUCHTENDGRUEN_OPACITY_35,
  COLOR_LEUCHTENDGRUEN_OPACITY_40,
  COLOR_LEUCHTENDGRUEN_OPACITY_45,
  COLOR_LEUCHTENDGRUEN_OPACITY_50,
  COLOR_LEUCHTENDGRUEN_OPACITY_55,
  COLOR_LEUCHTENDGRUEN_OPACITY_60,
  COLOR_LEUCHTENDGRUEN_OPACITY_65,
  COLOR_LEUCHTENDGRUEN_OPACITY_70,
  COLOR_LEUCHTENDGRUEN_OPACITY_75,
  COLOR_LEUCHTENDGRUEN_OPACITY_80,
  COLOR_LEUCHTENDGRUEN_OPACITY_85,
  COLOR_LEUCHTENDGRUEN_OPACITY_90,
  COLOR_LEUCHTENDGRUEN_OPACITY_95,
  COLOR_INDIABLAU_SHADE_1,
  COLOR_INDIABLAU_SHADE_2,
  COLOR_INDIABLAU_TINT_1,
  COLOR_INDIABLAU_TINT_2,
  COLOR_INDIABLAU_5,
  COLOR_INDIABLAU_10,
  COLOR_INDIABLAU_15,
  COLOR_INDIABLAU_20,
  COLOR_INDIABLAU_25,
  COLOR_INDIABLAU_30,
  COLOR_INDIABLAU_35,
  COLOR_INDIABLAU_40,
  COLOR_INDIABLAU_45,
  COLOR_INDIABLAU_50,
  COLOR_INDIABLAU_55,
  COLOR_INDIABLAU_60,
  COLOR_INDIABLAU_65,
  COLOR_INDIABLAU_70,
  COLOR_INDIABLAU_75,
  COLOR_INDIABLAU_80,
  COLOR_INDIABLAU_85,
  COLOR_INDIABLAU_90,
  COLOR_INDIABLAU_95,
  COLOR_INDIABLAU_OPACITY_5,
  COLOR_INDIABLAU_OPACITY_10,
  COLOR_INDIABLAU_OPACITY_15,
  COLOR_INDIABLAU_OPACITY_20,
  COLOR_INDIABLAU_OPACITY_25,
  COLOR_INDIABLAU_OPACITY_30,
  COLOR_INDIABLAU_OPACITY_35,
  COLOR_INDIABLAU_OPACITY_40,
  COLOR_INDIABLAU_OPACITY_45,
  COLOR_INDIABLAU_OPACITY_50,
  COLOR_INDIABLAU_OPACITY_55,
  COLOR_INDIABLAU_OPACITY_60,
  COLOR_INDIABLAU_OPACITY_65,
  COLOR_INDIABLAU_OPACITY_70,
  COLOR_INDIABLAU_OPACITY_75,
  COLOR_INDIABLAU_OPACITY_80,
  COLOR_INDIABLAU_OPACITY_85,
  COLOR_INDIABLAU_OPACITY_90,
  COLOR_INDIABLAU_OPACITY_95,
  COLOR_ALPENBLAU_SHADE_1,
  COLOR_ALPENBLAU_SHADE_2,
  COLOR_ALPENBLAU_TINT_1,
  COLOR_ALPENBLAU_TINT_2,
  COLOR_ALPENBLAU_5,
  COLOR_ALPENBLAU_10,
  COLOR_ALPENBLAU_15,
  COLOR_ALPENBLAU_20,
  COLOR_ALPENBLAU_25,
  COLOR_ALPENBLAU_30,
  COLOR_ALPENBLAU_35,
  COLOR_ALPENBLAU_40,
  COLOR_ALPENBLAU_45,
  COLOR_ALPENBLAU_50,
  COLOR_ALPENBLAU_55,
  COLOR_ALPENBLAU_60,
  COLOR_ALPENBLAU_65,
  COLOR_ALPENBLAU_70,
  COLOR_ALPENBLAU_75,
  COLOR_ALPENBLAU_80,
  COLOR_ALPENBLAU_85,
  COLOR_ALPENBLAU_90,
  COLOR_ALPENBLAU_95,
  COLOR_ALPENBLAU_OPACITY_5,
  COLOR_ALPENBLAU_OPACITY_10,
  COLOR_ALPENBLAU_OPACITY_15,
  COLOR_ALPENBLAU_OPACITY_20,
  COLOR_ALPENBLAU_OPACITY_25,
  COLOR_ALPENBLAU_OPACITY_30,
  COLOR_ALPENBLAU_OPACITY_35,
  COLOR_ALPENBLAU_OPACITY_40,
  COLOR_ALPENBLAU_OPACITY_45,
  COLOR_ALPENBLAU_OPACITY_50,
  COLOR_ALPENBLAU_OPACITY_55,
  COLOR_ALPENBLAU_OPACITY_60,
  COLOR_ALPENBLAU_OPACITY_65,
  COLOR_ALPENBLAU_OPACITY_70,
  COLOR_ALPENBLAU_OPACITY_75,
  COLOR_ALPENBLAU_OPACITY_80,
  COLOR_ALPENBLAU_OPACITY_85,
  COLOR_ALPENBLAU_OPACITY_90,
  COLOR_ALPENBLAU_OPACITY_95,
  COLOR_QUARTZGRAU10_SHADE_1,
  COLOR_QUARTZGRAU10_SHADE_2,
  COLOR_QUARTZGRAU10_TINT_1,
  COLOR_QUARTZGRAU10_TINT_2,
  COLOR_QUARTZGRAU10_5,
  COLOR_QUARTZGRAU10_10,
  COLOR_QUARTZGRAU10_15,
  COLOR_QUARTZGRAU10_20,
  COLOR_QUARTZGRAU10_25,
  COLOR_QUARTZGRAU10_30,
  COLOR_QUARTZGRAU10_35,
  COLOR_QUARTZGRAU10_40,
  COLOR_QUARTZGRAU10_45,
  COLOR_QUARTZGRAU10_50,
  COLOR_QUARTZGRAU10_55,
  COLOR_QUARTZGRAU10_60,
  COLOR_QUARTZGRAU10_65,
  COLOR_QUARTZGRAU10_70,
  COLOR_QUARTZGRAU10_75,
  COLOR_QUARTZGRAU10_80,
  COLOR_QUARTZGRAU10_85,
  COLOR_QUARTZGRAU10_90,
  COLOR_QUARTZGRAU10_95,
  COLOR_QUARTZGRAU10_OPACITY_5,
  COLOR_QUARTZGRAU10_OPACITY_10,
  COLOR_QUARTZGRAU10_OPACITY_15,
  COLOR_QUARTZGRAU10_OPACITY_20,
  COLOR_QUARTZGRAU10_OPACITY_25,
  COLOR_QUARTZGRAU10_OPACITY_30,
  COLOR_QUARTZGRAU10_OPACITY_35,
  COLOR_QUARTZGRAU10_OPACITY_40,
  COLOR_QUARTZGRAU10_OPACITY_45,
  COLOR_QUARTZGRAU10_OPACITY_50,
  COLOR_QUARTZGRAU10_OPACITY_55,
  COLOR_QUARTZGRAU10_OPACITY_60,
  COLOR_QUARTZGRAU10_OPACITY_65,
  COLOR_QUARTZGRAU10_OPACITY_70,
  COLOR_QUARTZGRAU10_OPACITY_75,
  COLOR_QUARTZGRAU10_OPACITY_80,
  COLOR_QUARTZGRAU10_OPACITY_85,
  COLOR_QUARTZGRAU10_OPACITY_90,
  COLOR_QUARTZGRAU10_OPACITY_95,
  COLOR_QUARTZGRAU20_SHADE_1,
  COLOR_QUARTZGRAU20_SHADE_2,
  COLOR_QUARTZGRAU20_TINT_1,
  COLOR_QUARTZGRAU20_TINT_2,
  COLOR_QUARTZGRAU20_5,
  COLOR_QUARTZGRAU20_10,
  COLOR_QUARTZGRAU20_15,
  COLOR_QUARTZGRAU20_20,
  COLOR_QUARTZGRAU20_25,
  COLOR_QUARTZGRAU20_30,
  COLOR_QUARTZGRAU20_35,
  COLOR_QUARTZGRAU20_40,
  COLOR_QUARTZGRAU20_45,
  COLOR_QUARTZGRAU20_50,
  COLOR_QUARTZGRAU20_55,
  COLOR_QUARTZGRAU20_60,
  COLOR_QUARTZGRAU20_65,
  COLOR_QUARTZGRAU20_70,
  COLOR_QUARTZGRAU20_75,
  COLOR_QUARTZGRAU20_80,
  COLOR_QUARTZGRAU20_85,
  COLOR_QUARTZGRAU20_90,
  COLOR_QUARTZGRAU20_95,
  COLOR_QUARTZGRAU20_OPACITY_5,
  COLOR_QUARTZGRAU20_OPACITY_10,
  COLOR_QUARTZGRAU20_OPACITY_15,
  COLOR_QUARTZGRAU20_OPACITY_20,
  COLOR_QUARTZGRAU20_OPACITY_25,
  COLOR_QUARTZGRAU20_OPACITY_30,
  COLOR_QUARTZGRAU20_OPACITY_35,
  COLOR_QUARTZGRAU20_OPACITY_40,
  COLOR_QUARTZGRAU20_OPACITY_45,
  COLOR_QUARTZGRAU20_OPACITY_50,
  COLOR_QUARTZGRAU20_OPACITY_55,
  COLOR_QUARTZGRAU20_OPACITY_60,
  COLOR_QUARTZGRAU20_OPACITY_65,
  COLOR_QUARTZGRAU20_OPACITY_70,
  COLOR_QUARTZGRAU20_OPACITY_75,
  COLOR_QUARTZGRAU20_OPACITY_80,
  COLOR_QUARTZGRAU20_OPACITY_85,
  COLOR_QUARTZGRAU20_OPACITY_90,
  COLOR_QUARTZGRAU20_OPACITY_95,
  COLOR_QUARTZGRAU50_SHADE_1,
  COLOR_QUARTZGRAU50_SHADE_2,
  COLOR_QUARTZGRAU50_TINT_1,
  COLOR_QUARTZGRAU50_TINT_2,
  COLOR_QUARTZGRAU50_5,
  COLOR_QUARTZGRAU50_10,
  COLOR_QUARTZGRAU50_15,
  COLOR_QUARTZGRAU50_20,
  COLOR_QUARTZGRAU50_25,
  COLOR_QUARTZGRAU50_30,
  COLOR_QUARTZGRAU50_35,
  COLOR_QUARTZGRAU50_40,
  COLOR_QUARTZGRAU50_45,
  COLOR_QUARTZGRAU50_50,
  COLOR_QUARTZGRAU50_55,
  COLOR_QUARTZGRAU50_60,
  COLOR_QUARTZGRAU50_65,
  COLOR_QUARTZGRAU50_70,
  COLOR_QUARTZGRAU50_75,
  COLOR_QUARTZGRAU50_80,
  COLOR_QUARTZGRAU50_85,
  COLOR_QUARTZGRAU50_90,
  COLOR_QUARTZGRAU50_95,
  COLOR_QUARTZGRAU50_OPACITY_5,
  COLOR_QUARTZGRAU50_OPACITY_10,
  COLOR_QUARTZGRAU50_OPACITY_15,
  COLOR_QUARTZGRAU50_OPACITY_20,
  COLOR_QUARTZGRAU50_OPACITY_25,
  COLOR_QUARTZGRAU50_OPACITY_30,
  COLOR_QUARTZGRAU50_OPACITY_35,
  COLOR_QUARTZGRAU50_OPACITY_40,
  COLOR_QUARTZGRAU50_OPACITY_45,
  COLOR_QUARTZGRAU50_OPACITY_50,
  COLOR_QUARTZGRAU50_OPACITY_55,
  COLOR_QUARTZGRAU50_OPACITY_60,
  COLOR_QUARTZGRAU50_OPACITY_65,
  COLOR_QUARTZGRAU50_OPACITY_70,
  COLOR_QUARTZGRAU50_OPACITY_75,
  COLOR_QUARTZGRAU50_OPACITY_80,
  COLOR_QUARTZGRAU50_OPACITY_85,
  COLOR_QUARTZGRAU50_OPACITY_90,
  COLOR_QUARTZGRAU50_OPACITY_95,
  COLOR_QUARTZGRAU75_SHADE_1,
  COLOR_QUARTZGRAU75_SHADE_2,
  COLOR_QUARTZGRAU75_TINT_1,
  COLOR_QUARTZGRAU75_TINT_2,
  COLOR_QUARTZGRAU75_5,
  COLOR_QUARTZGRAU75_10,
  COLOR_QUARTZGRAU75_15,
  COLOR_QUARTZGRAU75_20,
  COLOR_QUARTZGRAU75_25,
  COLOR_QUARTZGRAU75_30,
  COLOR_QUARTZGRAU75_35,
  COLOR_QUARTZGRAU75_40,
  COLOR_QUARTZGRAU75_45,
  COLOR_QUARTZGRAU75_50,
  COLOR_QUARTZGRAU75_55,
  COLOR_QUARTZGRAU75_60,
  COLOR_QUARTZGRAU75_65,
  COLOR_QUARTZGRAU75_70,
  COLOR_QUARTZGRAU75_75,
  COLOR_QUARTZGRAU75_80,
  COLOR_QUARTZGRAU75_85,
  COLOR_QUARTZGRAU75_90,
  COLOR_QUARTZGRAU75_95,
  COLOR_QUARTZGRAU75_OPACITY_5,
  COLOR_QUARTZGRAU75_OPACITY_10,
  COLOR_QUARTZGRAU75_OPACITY_15,
  COLOR_QUARTZGRAU75_OPACITY_20,
  COLOR_QUARTZGRAU75_OPACITY_25,
  COLOR_QUARTZGRAU75_OPACITY_30,
  COLOR_QUARTZGRAU75_OPACITY_35,
  COLOR_QUARTZGRAU75_OPACITY_40,
  COLOR_QUARTZGRAU75_OPACITY_45,
  COLOR_QUARTZGRAU75_OPACITY_50,
  COLOR_QUARTZGRAU75_OPACITY_55,
  COLOR_QUARTZGRAU75_OPACITY_60,
  COLOR_QUARTZGRAU75_OPACITY_65,
  COLOR_QUARTZGRAU75_OPACITY_70,
  COLOR_QUARTZGRAU75_OPACITY_75,
  COLOR_QUARTZGRAU75_OPACITY_80,
  COLOR_QUARTZGRAU75_OPACITY_85,
  COLOR_QUARTZGRAU75_OPACITY_90,
  COLOR_QUARTZGRAU75_OPACITY_95,
  COLOR_RED,
  COLOR_QUARTZGRAU,
  COLOR_SOMMERGELB,
  COLOR_SYSTEM_SUCCESS_LIGHT1,
  COLOR_SYSTEM_SUCCESS1,
  COLOR_SYSTEM_SUCCESS_DARK1,
  COLOR_SYSTEM_WARNING_LIGHT1,
  COLOR_SYSTEM_WARNING1,
  COLOR_SYSTEM_WARNING_DARK1,
  COLOR_SYSTEM_ERROR_LIGHT1,
  COLOR_SYSTEM_ERROR1,
  COLOR_SYSTEM_ERROR_DARK1,
  COLOR_SYSTEM_HIGHLIGHT_LIGHT1,
  COLOR_SYSTEM_HIGHLIGHT1,
  COLOR_SYSTEM_HIGHLIGHT_DARK1,

  COLOR_TRANSPARENT,
  COLOR_WHITE,
  COLOR_SYSTEM_SUCCESS_LIGHT,
  COLOR_SYSTEM_SUCCESS,
  COLOR_SYSTEM_SUCCESS_DARK,
  COLOR_SYSTEM_WARNING_LIGHT,
  COLOR_SYSTEM_WARNING,
  COLOR_SYSTEM_WARNING_DARK,
  COLOR_SYSTEM_ERROR_LIGHT,
  COLOR_SYSTEM_ERROR,
  COLOR_SYSTEM_ERROR_DARK,
  COLOR_SYSTEM_HIGHLIGHT_LIGHT,
  COLOR_SYSTEM_HIGHLIGHT,
  COLOR_SYSTEM_HIGHLIGHT_DARK,
  COLOR_GREY100,
  COLOR_GREY200,
  COLOR_GREY300,
  COLOR_GREY400,
  COLOR_GREY500,
  COLOR_GREY600,
  COLOR_GREY700,
  COLOR_GREY800,
  COLOR_GREY900
] as const;

export const THEME_COLORS = [
  "bright",
  "dark",
  "Schwarz",
  "Orientgelb",
  "Fasergruen",
  "Arktisgruen",
  "Karibikblau",
  "Bischofsrot",
  "Altrosa",
  "Kerzengelb",
  "Brillantkarmin",
  "Erdbeerrot",
  "Verkehrsorange",
  "Dahliengelb",
  "Leuchtendgruen",
  "Indiablau",
  "Alpenblau",
  "Quartzgrau10",
  "Quartzgrau20",
  "Quartzgrau50",
  "Quartzgrau75"
];

export const DEFAULT_PAGE_BACKGROUND_COLOR = "eon-bright" as const;

export const ACCORDION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  }
];
export const ANCHOR_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BASIC_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BOTTOM_DRAWER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BUSINESSCARD_AUTHOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BUSINESSCARD_CONTACT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CARD_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CARD_TEASER_OFFSET_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CAROUSEL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CHECKBOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz",
    scheme: {
      labelColor: COLOR_SCHWARZ,
      labelColorDisabled: COLOR_SCHWARZ,
      borderColor: COLOR_SCHWARZ,
      borderColorHover: COLOR_BRILLANTKARMIN,
      borderColorFocus: COLOR_BRILLANTKARMIN,
      borderColorSelected: COLOR_BRILLANTKARMIN,
      borderColorSelectedHover: COLOR_BRIGHT,
      borderColorSelectedFocus: COLOR_BRILLANTKARMIN_SHADE_2,
      backgroundColorHover: COLOR_BRIGHT,
      backgroundColorFocus: COLOR_BRILLANTKARMIN,
      backgroundColorDisabled: COLOR_BRIGHT,
      backgroundColorSelected: COLOR_BRIGHT,
      backgroundColorSelectedHover: COLOR_BRILLANTKARMIN,
      backgroundColorSelectedFocus: COLOR_BRIGHT,
      iconColor: COLOR_SCHWARZ,
      iconColorHover: COLOR_SCHWARZ,
      iconColorFocus: COLOR_BRILLANTKARMIN,
      iconColorSelected: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "bright"
  }
];
export const COLOR_SEPARATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTACT_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTACT_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTENT_AGGREGATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTENT_AGGREGATOR_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Fasergruen",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Arktisgruen",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Orientgelb",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Bischofsrot",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Altrosa",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Kerzengelb",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Brillantkarmin",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "Erdbeerrot",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "Verkehrsorange",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "Dahliengelb",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Leuchtendgruen",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Indiablau",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Alpenblau",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Quartzgrau10",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Quartzgrau20",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Quartzgrau50",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  },
  {
    schemeName: "Quartzgrau75",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "Schwarz",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "bright",
    scheme: {
      linkHoverColor: COLOR_SCHWARZ_TINT_1
    }
  }
];
export const CONTEXT_MENU_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const DATA_TABLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const DATE_PICKER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10",
    scheme: {
      popupBackgroundColor: COLOR_BRIGHT,
      dayBorderSelectedColor: COLOR_SCHWARZ,
      dayBackgroundTodayColor: COLOR_SCHWARZ,
      dayFontDisabledColor: COLOR_QUARTZGRAU50,
      dayFontOtherMonthColor: COLOR_QUARTZGRAU50,
      scrollbarThumbColor: COLOR_ARKTISGRUEN
    }
  },
  {
    schemeName: "bright"
  }
];
export const DIVIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const DROPDOWN_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz",
    scheme: {
      separatorColor: COLOR_QUARTZGRAU50,
      borderHoverColor: COLOR_SCHWARZ,
      borderActiveColor: COLOR_SCHWARZ,
      textColor: COLOR_SCHWARZ,
      textColorActive: COLOR_SCHWARZ,
      labelColor: COLOR_SCHWARZ,
      labelColorActive: COLOR_SCHWARZ,
      trailingIconColor: COLOR_BRILLANTKARMIN,
      disabledBorderColor: COLOR_SCHWARZ,
      disabledTrailingIconColor: COLOR_QUARTZGRAU50,
      disabledLabelColor: COLOR_SCHWARZ,
      optionsBorderBottomColor: COLOR_QUARTZGRAU75,
      optionsBackgroundColorHover: COLOR_QUARTZGRAU20,
      background: COLOR_BRIGHT,
      backgroundActive: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright"
  }
];
export const DROPDOWN_OPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10",
    scheme: {
      textColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "bright"
  }
];
export const ERROR_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const FILE_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const FILE_UPLOAD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10",
    scheme: {
      dropzoneBorderSingle: COLOR_SCHWARZ,
      dropzoneBorderMultiple: COLOR_SCHWARZ,
      dropzoneOnDragHoverBackground: COLOR_SCHWARZ,
      dropzoneLinkColor: COLOR_BRILLANTKARMIN,
      dropzoneLinkHoverColor: COLOR_BRILLANTKARMIN,
      dropzoneIconColor: COLOR_SCHWARZ,
      dropzoneIconHoverColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "bright"
  }
];
export const FOOTER_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const HEADLINE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const INFO_ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "Schwarz"
  }
];
export const INPUT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz",
    scheme: {
      textColor: COLOR_SCHWARZ,
      textColorActive: COLOR_SCHWARZ,
      labelColor: COLOR_SCHWARZ,
      labelColorActive: COLOR_SCHWARZ,
      trailingIconColor: COLOR_BRILLANTKARMIN,
      disabledTrailingIconColor: COLOR_QUARTZGRAU50,
      disabledLabelColor: COLOR_SCHWARZ,
      optionsBackgroundColorHover: COLOR_QUARTZGRAU20,
      background: COLOR_BRIGHT,
      backgroundActive: COLOR_BRIGHT,
      trailingIconColorActive: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "bright"
  }
];
export const LINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "bright"
  }
];
export const MAP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const MAP_INFO_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const MODAL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const MULTI_CONTENT_STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      loadingBarColor: COLOR_BRILLANTKARMIN,
      controlIconColor: COLOR_SCHWARZ,
      controlIconColorHover: COLOR_QUARTZGRAU50
    }
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const NUMBER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const OFFSET_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const OFFSET_TEASER5_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PAGE_HEADER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PICTOGRAM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PRELOADER_SQUARES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PROMO_FLAG_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const RADIO_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz",
    scheme: {
      focusColor: COLOR_BRILLANTKARMIN,
      checkedColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "bright"
  }
];
export const RTE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "transparent"
  }
];
export const SITELINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const SLIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const SPACER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const STEP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen",
    scheme: {
      inactiveStepColor: COLOR_ARKTISGRUEN,
      inactiveIconColor: COLOR_ARKTISGRUEN,
      activeTextColor: COLOR_SCHWARZ,
      inactiveTextColor: COLOR_SCHWARZ,
      doneTextColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const SWITCH_TOGGLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TABLE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Karibikblau",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Fasergruen",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Arktisgruen",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Orientgelb",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Bischofsrot",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Altrosa",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Kerzengelb",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Brillantkarmin",
    scheme: {
      tableBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "Erdbeerrot",
    scheme: {
      tableBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "Verkehrsorange",
    scheme: {
      tableBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "Dahliengelb",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Leuchtendgruen",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Indiablau",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Alpenblau",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Quartzgrau10",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Quartzgrau20",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Quartzgrau50",
    scheme: {
      tableBorderColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "Quartzgrau75",
    scheme: {
      tableBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "Schwarz",
    scheme: {
      tableBorderColor: COLOR_BRIGHT
    }
  }
];
export const TEXT_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const THIRD_LEVEL_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const THIRD_LEVEL_NAVIGATION_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const TILES_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TOOLTIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "bright"
  }
];
export const VIDEOPLAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin",
    scheme: {
      color: COLOR_QUARTZGRAU75,
      playButtonColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz",
    scheme: {
      color: COLOR_QUARTZGRAU75,
      playButtonColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "bright"
  }
];
export const VIOLATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTEXT_MENU_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PRELOADER_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const SEARCH_RESULT_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "bright"
  }
];
export const TABS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_BRIGHT_SHADE_1
    }
  },
  {
    schemeName: "Karibikblau",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_KARIBIKBLAU_SHADE_1
    }
  },
  {
    schemeName: "Fasergruen",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_FASERGRUEN_SHADE_1
    }
  },
  {
    schemeName: "Arktisgruen",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_ARKTISGRUEN_SHADE_1
    }
  },
  {
    schemeName: "Orientgelb",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_ORIENTGELB_SHADE_1
    }
  },
  {
    schemeName: "Bischofsrot",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_BISCHOFSROT_SHADE_1
    }
  },
  {
    schemeName: "Altrosa",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_ALTROSA_SHADE_1
    }
  },
  {
    schemeName: "Kerzengelb",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_KERZENGELB_SHADE_1
    }
  },
  {
    schemeName: "Brillantkarmin",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_BRILLANTKARMIN_TINT_1
    }
  },
  {
    schemeName: "Erdbeerrot",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_ERDBEERROT_TINT_1
    }
  },
  {
    schemeName: "Verkehrsorange",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_VERKEHRSORANGE_TINT_1
    }
  },
  {
    schemeName: "Dahliengelb",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_DAHLIENGELB_SHADE_1
    }
  },
  {
    schemeName: "Leuchtendgruen",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_LEUCHTENDGRUEN_SHADE_1
    }
  },
  {
    schemeName: "Indiablau",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_INDIABLAU_SHADE_1
    }
  },
  {
    schemeName: "Alpenblau",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_ALPENBLAU_SHADE_1
    }
  },
  {
    schemeName: "Quartzgrau10",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_QUARTZGRAU10_SHADE_1
    }
  },
  {
    schemeName: "Quartzgrau20",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_QUARTZGRAU20_SHADE_1
    }
  },
  {
    schemeName: "Quartzgrau50",
    scheme: {
      textColor: COLOR_SCHWARZ,
      tabBorderColor: COLOR_SCHWARZ,
      tabActiveBorderColor: COLOR_SCHWARZ,
      tabHoverColor: COLOR_QUARTZGRAU50_SHADE_1
    }
  },
  {
    schemeName: "Quartzgrau75",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_QUARTZGRAU75_TINT_1
    }
  },
  {
    schemeName: "Schwarz",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_SCHWARZ_TINT_1
    }
  }
];
export const CLICKABLE_IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT,
      textHoverColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT,
      textHoverColor: COLOR_SCHWARZ
    }
  },
  {
    schemeName: "bright"
  }
];
export const READ_MORE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin",
    scheme: {
      rulerArrowColor: COLOR_BRIGHT,
      rulerColorHover: COLOR_BRILLANTKARMIN,
      rulerButtonHoverColor: COLOR_BRILLANTKARMIN,
      rulerColor: COLOR_BRILLANTKARMIN,
      textColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz",
    scheme: {
      rulerArrowColor: COLOR_BRIGHT,
      rulerColorHover: COLOR_SCHWARZ,
      rulerButtonHoverColor: COLOR_BRILLANTKARMIN,
      rulerColor: COLOR_BRILLANTKARMIN,
      textColor: COLOR_BRILLANTKARMIN
    }
  },
  {
    schemeName: "bright"
  }
];
export const ANSWER_CARD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "bright"
  }
];
export const ANSWER_CARD_GROUP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "bright"
  }
];
export const BADGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BREADCRUMB_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BULLET_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BULLET_LIST_DEPRECATED_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CAPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CONTACT_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const DATE_EVENT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const FORM_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Red"
  }
];
export const LINKLIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "bright"
  }
];
export const PROGRESS_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const STEPS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TAG_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TEXT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const COMPASS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CHIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PAGINATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const IMAGE_GALLERY_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const IMAGE_GALLERY_OVERVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const IMAGE_GALLERY_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const BACKGROUND_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const BADGES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CHECKBOX_GROUP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const FORM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const GRID_CONTROL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  }
];
export const MT_CAPTCHA_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PAGE_WRAPPER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const RADIO_BUTTON_GROUP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TAB_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const TAG_PILL_GROUP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const PICTOGRAM_BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];
export const STICKY_BANNER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "Karibikblau"
  },
  {
    schemeName: "Fasergruen"
  },
  {
    schemeName: "Arktisgruen"
  },
  {
    schemeName: "Orientgelb"
  },
  {
    schemeName: "Bischofsrot"
  },
  {
    schemeName: "Altrosa"
  },
  {
    schemeName: "Kerzengelb"
  },
  {
    schemeName: "Brillantkarmin"
  },
  {
    schemeName: "Erdbeerrot"
  },
  {
    schemeName: "Verkehrsorange"
  },
  {
    schemeName: "Dahliengelb"
  },
  {
    schemeName: "Leuchtendgruen"
  },
  {
    schemeName: "Indiablau"
  },
  {
    schemeName: "Alpenblau"
  },
  {
    schemeName: "Quartzgrau10"
  },
  {
    schemeName: "Quartzgrau20"
  },
  {
    schemeName: "Quartzgrau50"
  },
  {
    schemeName: "Quartzgrau75"
  },
  {
    schemeName: "Schwarz"
  },
  {
    schemeName: "bright"
  }
];

export interface AccordionSchemeConfiguration<T> {
  Quartzgrau10?: T;
  Orientgelb?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Karibikblau?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  bright?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
}
export interface AnchorNavigationSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface BasicTeaserSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BottomDrawerSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BoxSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BusinesscardAuthorSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BusinesscardContactSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ButtonSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CardTeaserSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CardTeaserOffsetSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CarouselSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CheckboxSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface ColorSeparatorSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContactBarSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContactLayerSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContentAggregatorSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContentAggregatorItemSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContextMenuItemSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface DataTableSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface DatePickerSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface DividerSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface DropdownSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface DropdownOptionSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface ErrorMessageSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface FilePreviewSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface FileUploadSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface FooterBarSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface HeadlineSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface IconSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface ImageSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface InfoIconSchemeConfiguration<T> {
  Brillantkarmin?: T;
  bright?: T;
  Schwarz?: T;
}
export interface InputSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface LinkSchemeConfiguration<T> {
  Schwarz?: T;
  Orientgelb?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Karibikblau?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  bright?: T;
}
export interface MapSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface MapInfoLayerSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ModalSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface MultiContentStageSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface NavigationSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface NumberSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface OffsetTeaserSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface OffsetTeaser5SchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PageHeaderSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface PictogramSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PreloaderSquaresSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PromoFlagSchemeConfiguration<T> {
  Arktisgruen?: T;
  Fasergruen?: T;
  Karibikblau?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface RadioButtonSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface RteRendererSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface SectionSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  transparent?: T;
}
export interface SitelinkSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface SliderSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface SpacerSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface StageSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface StepSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface SwitchToggleSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface TableRendererSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface TextTeaserSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ThirdLevelNavigationSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface ThirdLevelNavigationItemSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface TilesTeaserSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface TooltipSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface VideoplayerSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ViolatorSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ContextMenuSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface PreloaderCircleSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface SearchResultItemSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  bright?: T;
}
export interface TabsSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface ClickableImageSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ReadMoreSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface AnswerCardSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface AnswerCardGroupSchemeConfiguration<T> {
  Quartzgrau10?: T;
  bright?: T;
}
export interface BadgeSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BreadcrumbSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface BulletListSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface BulletListDeprecatedSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface CaptionSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface ContactListSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface DateEventSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface FormMessageSchemeConfiguration<T> {
  Red?: T;
}
export interface LinklistSchemeConfiguration<T> {
  Schwarz?: T;
  Orientgelb?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Karibikblau?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  bright?: T;
}
export interface ProgressCircleSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface StepsSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface TagPillSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface TextSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface CompassSchemeConfiguration<T> {
  Brillantkarmin?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ListSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ChipSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PaginationSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ImageGalleryItemSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ImageGalleryOverviewSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface ImageGalleryPreviewSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface BackgroundSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface BadgesSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CheckboxGroupSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface FormSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface GridControlSchemeConfiguration<T> {
  bright?: T;
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
}
export interface MtCaptchaSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PageWrapperSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface RadioButtonGroupSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface TabNavigationSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface TagPillGroupSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface CircleSchemeConfiguration<T> {
  Schwarz?: T;
  bright?: T;
}
export interface PictogramBoxSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
export interface StickyBannerSchemeConfiguration<T> {
  Karibikblau?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Orientgelb?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
  Schwarz?: T;
  bright?: T;
}
//add Components Color-Variables from colorDefinitions
export const ANCHOR_NAVIGATION_BACKGROUND_COLOR = "eon-anchor-navigation-background-color" as const;
export const ANCHOR_NAVIGATION_BACKGROUND_HOVER_COLOR = "eon-anchor-navigation-background-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_COLOR = "eon-anchor-navigation-icon-color" as const;
export const ANCHOR_NAVIGATION_ICON_HIGHLIGHT_COLOR = "eon-anchor-navigation-icon-highlight-color" as const;
export const ANCHOR_NAVIGATION_ICON_HOVER_COLOR = "eon-anchor-navigation-icon-hover-color" as const;
export const ANCHOR_NAVIGATION_ITEM_BACKGROUND_COLOR = "eon-anchor-navigation-item-background-color" as const;
export const ANCHOR_NAVIGATION_ITEM_HOVER_COLOR = "eon-anchor-navigation-item-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_COLOR = "eon-anchor-navigation-link-color" as const;
export const ANCHOR_NAVIGATION_LINK_HIGHLIGHT_COLOR = "eon-anchor-navigation-link-highlight-color" as const;
export const ANCHOR_NAVIGATION_LINK_HOVER_COLOR = "eon-anchor-navigation-link-hover-color" as const;
export const CAROUSEL_CONTROL_COLOR_BRIGHT = "eon-carousel-control-color-bright" as const;
export const CAROUSEL_CONTROL_COLOR_DARK = "eon-carousel-control-color-dark" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_BRIGHT = "eon-carousel-control-icon-color-bright" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_DARK = "eon-carousel-control-icon-color-dark" as const;
export const COLOR_SEPARATOR_FIRST_COLOR = "eon-color-separator-first-color" as const;
export const COLOR_SEPARATOR_SECOND_COLOR = "eon-color-separator-second-color" as const;
export const COLOR_SEPARATOR_THIRD_COLOR = "eon-color-separator-third-color" as const;
export const CONTACT_BAR_MODAL_BACKGROUND_COLOR = "eon-contact-bar-modal-background-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_ACTIVE_COLOR = "eon-context-menu-item-background-active-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_HOVER_COLOR = "eon-context-menu-item-background-hover-color" as const;
export const DATA_TABLE_CELL_BACKGROUND = "eon-data-table-cell-background" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN = "eon-data-table-cell-background-even" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN_HOVER = "eon-data-table-cell-background-even-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_HOVER = "eon-data-table-cell-background-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD = "eon-data-table-cell-background-odd" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD_HOVER = "eon-data-table-cell-background-odd-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED = "eon-data-table-cell-background-selected" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED_HOVER = "eon-data-table-cell-background-selected-hover" as const;
export const DATA_TABLE_CELL_BORDER = "eon-data-table-cell-border" as const;
export const DATA_TABLE_CELL_BORDER_EVEN = "eon-data-table-cell-border-even" as const;
export const DATA_TABLE_CELL_BORDER_EVEN_HOVER = "eon-data-table-cell-border-even-hover" as const;
export const DATA_TABLE_CELL_BORDER_HOVER = "eon-data-table-cell-border-hover" as const;
export const DATA_TABLE_CELL_BORDER_ODD = "eon-data-table-cell-border-odd" as const;
export const DATA_TABLE_CELL_BORDER_ODD_HOVER = "eon-data-table-cell-border-odd-hover" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED = "eon-data-table-cell-border-selected" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED_HOVER = "eon-data-table-cell-border-selected-hover" as const;
export const DATA_TABLE_CELL_COLOR = "eon-data-table-cell-color" as const;
export const DATA_TABLE_CELL_ICON_COLOR = "eon-data-table-cell-icon-color" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND = "eon-data-table-head-cell-background" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT = "eon-data-table-head-cell-background-act" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT_HOVER = "eon-data-table-head-cell-background-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_HOVER = "eon-data-table-head-cell-background-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER = "eon-data-table-head-cell-border" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT = "eon-data-table-head-cell-border-act" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT_HOVER = "eon-data-table-head-cell-border-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_HOVER = "eon-data-table-head-cell-border-hover" as const;
export const DATA_TABLE_HEAD_CELL_COLOR = "eon-data-table-head-cell-color" as const;
export const DATA_TABLE_HEAD_CELL_ICON_COLOR = "eon-data-table-head-cell-icon-color" as const;
export const DATA_TABLE_TOOLBAR_BACKGROUND = "eon-data-table-toolbar-background" as const;
export const DATA_TABLE_TOOLBAR_COLOR = "eon-data-table-toolbar-color" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_BACKGROUND = "eon-data-table-toolbar-selected-background" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_COLOR = "eon-data-table-toolbar-selected-color" as const;
export const FOOTER_BAR_BACKGROUND_COLOR = "eon-footer-bar-background-color" as const;
export const FOOTER_BAR_COPYRIGHT_COLOR = "eon-footer-bar-copyright-color" as const;
export const FOOTER_BAR_ICON_COLOR = "eon-footer-bar-icon-color" as const;
export const FOOTER_BAR_ICON_HOVER_COLOR = "eon-footer-bar-icon-hover-color" as const;
export const FOOTER_BAR_LINK_COLOR = "eon-footer-bar-link-color" as const;
export const FOOTER_BAR_LINK_HOVER_COLOR = "eon-footer-bar-link-hover-color" as const;
export const MAP_SVG_COLOR = "eon-map-svg-color" as const;
export const MODAL_FULL_WIDTH_BACKGROUND_COLOR = "eon-modal-full-width-background-color" as const;
export const MODAL_FULL_WIDTH_ON_FILTER_BLUR_BACKGROUND_COLOR = "eon-modal-full-width-on-filter-blur-background-color" as const;
export const MODAL_WRAPPER_BACKGROUND_COLOR = "eon-modal-wrapper-background-color" as const;
export const NAVIGATION_BOX_SHADOW = "eon-navigation-box-shadow" as const;
export const NAVIGATION_COLUMN_ALIGN_ITEMS = "eon-navigation-column-align-items" as const;
export const NAVIGATION_COLUMN_GAP = "eon-navigation-column-gap" as const;
export const NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-navigation-flyout-divider-bg-color" as const;
export const NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-navigation-flyout-link-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-navigation-flyout-link-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-large-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-navigation-flyout-link-large-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-large-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-large-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-navigation-flyout-link-large-font-color-hover" as const;
export const NAVIGATION_FOCUS_BORDER_COLOR = "eon-navigation-focus-border-color" as const;
export const NAVIGATION_MAIN_BG_COLOR = "eon-navigation-main-bg-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR = "eon-navigation-main-border-color" as const;
export const NAVIGATION_MAIN_BORDER_WIDTH = "eon-navigation-main-border-width" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR = "eon-navigation-main-icon-link-bg-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-icon-link-bg-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-main-icon-link-bg-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-main-icon-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-main-icon-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR = "eon-navigation-main-icon-link-border-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-icon-link-border-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-icon-link-border-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-icon-link-border-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-icon-link-border-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR = "eon-navigation-main-icon-link-font-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-icon-link-font-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-icon-link-font-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-icon-link-font-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-main-icon-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-main-link-bg-color" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-link-bg-color-active" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-navigation-main-link-bg-color-current" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-navigation-main-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-navigation-main-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-navigation-main-link-border-color" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-link-border-color-active" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-link-border-color-current" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-link-border-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-link-border-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_RADIUS = "eon-navigation-main-link-border-radius" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-navigation-main-link-font-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-link-font-color-active" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-link-font-color-current" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-link-font-color-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-navigation-main-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_STYLE = "eon-navigation-main-link-font-style" as const;
export const NAVIGATION_MAIN_LINK_PADDING = "eon-navigation-main-link-padding" as const;
export const NAVIGATION_MAIN_MARGIN_BOTTOM = "eon-navigation-main-margin-bottom" as const;
export const NAVIGATION_MAIN_SUB_BG_COLOR = "eon-navigation-main-sub-bg-color" as const;
export const NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-navigation-main-sub-box-shadow" as const;
export const NAVIGATION_META_BG_COLOR = "eon-navigation-meta-bg-color" as const;
export const NAVIGATION_META_BORDER_COLOR = "eon-navigation-meta-border-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR = "eon-navigation-meta-link-bg-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-navigation-meta-link-bg-color-current" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-bg-color-current-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-bg-color-current-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-navigation-meta-link-bg-color-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-navigation-meta-link-bg-color-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR = "eon-navigation-meta-link-border-color" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-navigation-meta-link-border-color-current" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-border-color-current-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-border-color-current-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-navigation-meta-link-border-color-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-navigation-meta-link-border-color-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR = "eon-navigation-meta-link-font-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-navigation-meta-link-font-color-current" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-font-color-current-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-font-color-current-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-navigation-meta-link-font-color-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-navigation-meta-link-font-color-hover" as const;
export const NAVIGATION_MOBILE_BG_COLOR = "eon-navigation-mobile-bg-color" as const;
export const NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-navigation-mobile-link-border-color" as const;
export const NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-navigation-mobile-link-font-color" as const;
export const NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-navigation-mobile-link-highlight-border-color" as const;
export const NAVIGATION_TOOLBAR_BG_COLOR = "eon-navigation-toolbar-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR = "eon-navigation-toolbar-icon-link-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-bg-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-bg-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-toolbar-icon-link-bg-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR = "eon-navigation-toolbar-icon-link-font-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-font-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-font-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-font-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-font-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-font-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-font-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-font-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-toolbar-icon-link-font-color-hover" as const;
export const NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-navigation-toolbar-sub-bg-color" as const;
export const NAVIGATION_MOBILE_NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-mobile-navigation-main-link-bg-color" as const;
export const PRELOADER_SQUARES_THEME_COLOR1 = "eon-preloader-squares-theme-color1" as const;
export const SECTION_VIDEO_CONTROL_COLOR_DARK = "eon-section-video-control-color-dark" as const;
export const SECTION_VIDEO_CONTROL_COLOR_LIGHT = "eon-section-video-control-color-light" as const;
export const STAGE_BLURRED_BACKGROUND = "eon-stage-blurred-background" as const;
export const STAGE_INDICATOR_COLOR_LIGHT = "eon-stage-indicator-color-light" as const;
export const STAGE_VIDEO_CONTROL_COLOR_DARK = "eon-stage-video-control-color-dark" as const;
export const STAGE_VIDEO_CONTROL_COLOR_LIGHT = "eon-stage-video-control-color-light" as const;
export const TABLE_RENDERER_ROW_HOVER_COLOR = "eon-table-renderer-row-hover-color" as const;
export const VIDEOPLAYER_CONTROLS_BACKGROUND = "eon-videoplayer-controls-background" as const;
export const VIDEOPLAYER_ERROR_BACKGROUND_COLOR = "eon-videoplayer-error-background-color" as const;
export const VIDEOPLAYER_ERROR_COLOR = "eon-videoplayer-error-color" as const;
export const VIDEOPLAYER_FOCUS_OUTLINE_COLOR = "eon-videoplayer-focus-outline-color" as const;
export const VIDEOPLAYER_ICON_COLOR = "eon-videoplayer-icon-color" as const;
export const VIDEOPLAYER_PROGRESS_BACKGROUND = "eon-videoplayer-progress-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_ACTIVE_BACKGROUND = "eon-videoplayer-progress-bar-active-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BACKGROUND = "eon-videoplayer-progress-bar-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_COLOR = "eon-videoplayer-progress-bar-button-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_FOCUS = "eon-videoplayer-progress-bar-button-focus" as const;
export const VIDEOPLAYER_PROGRESS_BAR_COLOR = "eon-videoplayer-progress-bar-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-play-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-play-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_TIME_COLOR = "eon-videoplayer-progress-bar-time-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_VALUE_BACKGROUND = "eon-videoplayer-progress-bar-value-background" as const;
export const VIDEOPLAYER_PROGRESS_COLOR = "eon-videoplayer-progress-color" as const;
export const CONTEXT_MENU_BORDER_COLOR = "eon-context-menu-border-color" as const;
export const CONTEXT_MENU_DIVIDER_BORDER_COLOR = "eon-context-menu-divider-border-color" as const;
export const PRELOADER_CIRCLE_THEME_COLOR1 = "eon-preloader-circle-theme-color1" as const;
export const PRELOADER_CIRCLE_THEME_COLOR2 = "eon-preloader-circle-theme-color2" as const;
export const PRELOADER_CIRCLE_THEME_COLOR3 = "eon-preloader-circle-theme-color3" as const;
export const PRELOADER_CIRCLE_THEME_COLOR4 = "eon-preloader-circle-theme-color4" as const;
export const SEARCH_RESULT_ITEM_MARK_COLOR = "eon-search-result-item-mark-color" as const;
export const SEARCH_RESULT_ITEM_VISITED_COLOR = "eon-search-result-item-visited-color" as const;

export const SCHEME_ALIAS_CONFIG = {
  ACCORDION: {},
  ANCHOR_NAVIGATION: {},
  BASIC_TEASER: {},
  BOTTOM_DRAWER: {},
  BOX: {},
  BUSINESSCARD_AUTHOR: {},
  BUSINESSCARD_CONTACT: {},
  BUTTON: {},
  CARD_TEASER: {},
  CARD_TEASER_OFFSET: {},
  CAROUSEL: {},
  CHECKBOX: {},
  COLOR_SEPARATOR: {},
  CONTACT_BAR: {},
  CONTACT_LAYER: {},
  CONTENT_AGGREGATOR: {},
  CONTENT_AGGREGATOR_ITEM: {},
  CONTEXT_MENU_ITEM: {},
  DATA_TABLE: {},
  DATE_PICKER: {},
  DIVIDER: {},
  DROPDOWN: {},
  DROPDOWN_OPTION: {},
  ERROR_MESSAGE: {},
  FILE_PREVIEW: {},
  FILE_UPLOAD: {},
  FOOTER_BAR: {},
  HEADLINE: {},
  ICON: {},
  IMAGE: {},
  INFO_ICON: {},
  INPUT: {},
  LINK: {},
  MAP: {},
  MAP_INFO_LAYER: {},
  MODAL: {},
  MULTI_CONTENT_STAGE: {},
  NAVIGATION: {},
  NUMBER: {},
  OFFSET_TEASER: {},
  OFFSET_TEASER5: {},
  PAGE_HEADER: {},
  PAGE_HEADER_CIRCLE: {},
  PICTOGRAM: {},
  PRELOADER_SQUARES: {},
  PROMO_FLAG: {},
  RADIO_BUTTON: {},
  RTE_RENDERER: {},
  SECTION: {},
  SITELINK: {},
  SLIDER: {},
  SPACER: {},
  STAGE: {},
  STEP: {},
  SWITCH_TOGGLE: {},
  TABLE_RENDERER: {},
  TEXT_TEASER: {},
  THIRD_LEVEL_NAVIGATION: {},
  THIRD_LEVEL_NAVIGATION_ITEM: {},
  TILES_TEASER: {},
  TOOLTIP: {},
  VIDEOPLAYER: {},
  VIOLATOR: {},
  CONTEXT_MENU: {},
  PRELOADER_CIRCLE: {},
  SEARCH_RESULT_ITEM: {},
  TABS: {},
  CLICKABLE_IMAGE: {},
  READ_MORE: {},
  ANSWER_CARD: {},
  ANSWER_CARD_GROUP: {},
  BADGE: {},
  BREADCRUMB: {},
  BULLET_LIST: {},
  BULLET_LIST_DEPRECATED: {},
  CAPTION: {},
  CONTACT_LIST: {},
  DATE_EVENT: {},
  FORM_MESSAGE: {},
  LINKLIST: {},
  PROGRESS_CIRCLE: {},
  STEPS: {},
  TAG_PILL: {},
  TEXT: {},
  COMPASS: {},
  LIST: {},
  CHIP: {},
  PAGINATION: {},
  IMAGE_GALLERY_ITEM: {},
  IMAGE_GALLERY_OVERVIEW: {},
  IMAGE_GALLERY_PREVIEW: {},
  BACKGROUND: {},
  BADGES: {},
  CHECKBOX_GROUP: {},
  FORM: {},
  GRID_CONTROL: {},
  MT_CAPTCHA: {},
  PAGE_WRAPPER: {},
  RADIO_BUTTON_GROUP: {},
  TAB_NAVIGATION: {},
  TAG_PILL_GROUP: {},
  CIRCLE: {},
  PICTOGRAM_BOX: {},
  STICKY_BANNER: {}
};

export const BACKGROUND_COLORS = [
  // COLOR_ULTRALIGHTGREY,
  // COLOR_WHITE,
  // COLOR_LIGHTGREY,

  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_SCHWARZ,
  COLOR_ORIENTGELB,
  COLOR_FASERGRUEN,
  COLOR_ARKTISGRUEN,
  COLOR_KARIBIKBLAU,
  COLOR_BISCHOFSROT,
  COLOR_ALTROSA,
  COLOR_KERZENGELB,
  COLOR_BRILLANTKARMIN,
  COLOR_ERDBEERROT,
  COLOR_VERKEHRSORANGE,
  COLOR_DAHLIENGELB,
  COLOR_LEUCHTENDGRUEN,
  COLOR_INDIABLAU,
  COLOR_ALPENBLAU,
  COLOR_QUARTZGRAU10,
  COLOR_QUARTZGRAU20,
  COLOR_QUARTZGRAU50,
  COLOR_QUARTZGRAU75
];

export interface BackgroundSchemeConfiguration<T> {
  // white?: T;
  // lightgrey?: T;
  // ultralightgrey?: T;

  bright?: T;
  dark?: T;
  Schwarz?: T;
  Orientgelb?: T;
  Fasergruen?: T;
  Arktisgruen?: T;
  Karibikblau?: T;
  Bischofsrot?: T;
  Altrosa?: T;
  Kerzengelb?: T;
  Brillantkarmin?: T;
  Erdbeerrot?: T;
  Verkehrsorange?: T;
  Dahliengelb?: T;
  Leuchtendgruen?: T;
  Indiablau?: T;
  Alpenblau?: T;
  Quartzgrau10?: T;
  Quartzgrau20?: T;
  Quartzgrau50?: T;
  Quartzgrau75?: T;
}

interface ColorMap {
  [name: string]: string | boolean | number;
}

export interface SchemeConfig {
  schemeName: string;
  scheme?: ColorMap;
}

export type EonColor = typeof EON_COLORS[number];

/* PLOP_INJECT_ALIGNMENT */
